// AUTO-GENERATED by backend/scripts/forecast_importer.py. Do not edit by hand.
// Regenerate by running: python -m scripts.forecast_importer <path-to-xlsx-or-csv>
// NOTE: figures below are MOCK/DEMO data (jittered), not real financials.

export const forecastPayload2026_2031 = {
  "currency": "CAD",
  "byYear": {
    "2026": {
      "depts": {
        "Engineering": {
          "monthly_total": [
            -49724,
            -44392,
            -68954,
            -61509,
            -44300,
            -59307,
            -42686,
            -51990,
            -62712,
            -53700,
            -52904,
            -59464
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -54428,
                -43933,
                -49349,
                -42216,
                -42473,
                -66896,
                -41161,
                -50003,
                -69412,
                -51808,
                -52818,
                -68046
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1070,
                -937,
                -834,
                -860,
                -1104,
                -983,
                -1055,
                -1018,
                -923,
                -797,
                -1017,
                -759
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -4546,
                -5447,
                -5754,
                -5445,
                -4001,
                -4613,
                -4376,
                -5081,
                -3946,
                -5690,
                -4558,
                -4158
              ]
            }
          }
        },
        "Electrical & Software": {
          "monthly_total": [
            -120577,
            -124969,
            -207803,
            -161767,
            -298938,
            -347058,
            -125346,
            -124702,
            -139923,
            -151443,
            -83822,
            -139475
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -946,
                -991,
                -734,
                -49110,
                -43941,
                -862,
                -975,
                -719,
                -737,
                -736,
                -974,
                -830
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -26990,
                -18367,
                -21167,
                -20968,
                -22808,
                -1301,
                -1458,
                -1499,
                -1530,
                -1468,
                -1611,
                -1249
              ]
            },
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                -116,
                -146,
                -153,
                -19274,
                -137,
                -124,
                -131,
                -148,
                -143,
                -161,
                -150,
                -154
              ]
            },
            "51011": {
              "name": "Device Component",
              "monthly": [
                -1696,
                -1829,
                -1706,
                -2153,
                -2124,
                -215544,
                -1742,
                -2082,
                -1935,
                -2158,
                -1903,
                -1890
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                0,
                0,
                0,
                0,
                -81274,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3621,
                -2660,
                -3333,
                -2753,
                -2856,
                -3386,
                -4093,
                -3538,
                -3975,
                -3063,
                -3504,
                -3784
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -586,
                -610,
                -547,
                -658,
                -591,
                -527,
                -623,
                -630,
                -678,
                -533,
                -597,
                -714
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -223,
                -267,
                -327,
                -711,
                -963,
                -745,
                -964,
                -974,
                -718,
                -1033,
                -769,
                -832
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -1023,
                -741,
                -1095,
                -942,
                -826,
                -728,
                -836,
                -951,
                -864,
                -906,
                -943,
                -1074
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -1931,
                -1597,
                -59237,
                -1919,
                -1783,
                -1735,
                -52073,
                -33334,
                -1967,
                -64803,
                -1375,
                -1973
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -61490,
                -70451,
                -87999,
                -67750,
                -53335,
                -82791,
                -85730,
                -84132,
                -78867,
                -66517,
                -86211,
                -111882
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1540,
                -1486,
                -1235,
                -1405,
                -1172,
                -1552,
                -1480,
                -1193,
                -1223,
                -1700,
                -1518,
                -1171
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -7333,
                -6742,
                -8272,
                -8821,
                -6756,
                -7633,
                -7482,
                -6171,
                -7296,
                -6882,
                -6380,
                -7634
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -7001,
                -8122,
                -6846,
                -7963,
                -6898,
                -1621,
                -1530,
                -1569,
                -1408,
                -1709,
                -1650,
                -1989
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -286,
                -297,
                -367,
                -358,
                -327,
                -348,
                -295,
                -346,
                -363,
                -364,
                -364,
                -364
              ]
            }
          }
        },
        "Mechanical Design": {
          "monthly_total": [
            -569905,
            -334963,
            -310980,
            -366818,
            -299106,
            -287578,
            -1176446,
            -235661,
            -295549,
            -226423,
            -259002,
            -293879
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -371,
                -373,
                -408,
                -4135,
                -5759,
                -5458,
                -4072,
                -5481,
                -5490,
                -4538,
                -4814,
                -4873
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -671,
                -680,
                -834,
                -625,
                -655,
                -742,
                -626,
                -645,
                -650,
                -688,
                -740,
                -819
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -366659,
                -140942,
                -166877,
                -204977,
                -166505,
                -134742,
                -851567,
                -107778,
                -89814,
                -82768,
                -74921,
                -76244
              ]
            },
            "51025": {
              "name": "Fixturing & Jigs",
              "monthly": [
                -10324,
                -11092,
                -9540,
                -11999,
                -12995,
                -11733,
                -586,
                -449,
                -563,
                -476,
                -425,
                -473
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3597,
                -4159,
                -4841,
                -3837,
                -4754,
                -3760,
                -3514,
                -4457,
                -4570,
                -3699,
                -4799,
                -3617
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -32385,
                -33175,
                -31788,
                -27370,
                -36089,
                -27781,
                -19873,
                -20019,
                -19672,
                -14978,
                -21109,
                -20812
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -438,
                -414,
                -579,
                -486,
                -454,
                -530,
                -470,
                -439,
                -421,
                -509,
                -588,
                -463
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -83106,
                -87880,
                -101553,
                -86152,
                -100963,
                -140969,
                -84382,
                -84122,
                -131782,
                -105897,
                -82615,
                -135197
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1912,
                -2063,
                -1948,
                -1719,
                -1534,
                -1891,
                -1504,
                -1471,
                -2118,
                -1968,
                -1891,
                -2047
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -10866,
                -8723,
                -10854,
                -8349,
                -11136,
                -8589,
                -8125,
                -8852,
                -10063,
                -8388,
                -8301,
                -9341
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1832,
                -1932,
                -1699,
                -2090,
                -70508,
                -2194,
                -1625,
                -1924,
                -1778,
                -1936,
                -1754,
                -1584
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -373,
                -351,
                -423,
                -394,
                -402,
                -423,
                -312,
                -439,
                -366,
                -407,
                -392,
                -321
              ]
            }
          }
        },
        "Operations": {
          "monthly_total": [
            -126750,
            -71042,
            -55756,
            -69735,
            -70271,
            -155540,
            -185317,
            -64460,
            -281152,
            -297442,
            -268965,
            -246119
          ],
          "by_gl": {
            "51011": {
              "name": "Device Component",
              "monthly": [
                -93835,
                -45525,
                -49018,
                -42975,
                -76308,
                -142162,
                -180192,
                -58591,
                -259171,
                -271529,
                -194116,
                -225720
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -10197,
                -14235,
                -13081,
                -12116,
                -10368,
                0,
                0,
                -12262,
                -15966,
                -13687,
                -13316,
                -14616
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -167,
                -161,
                -174,
                -215,
                -223,
                -203,
                -225,
                -239,
                -219,
                -190,
                -222,
                -223
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1185,
                -1212,
                -1215,
                -1239,
                -882,
                -851,
                -1130,
                -878,
                -1141,
                -1163,
                -1018,
                -998
              ]
            }
          }
        },
        "Machine Shop & Metrology": {
          "monthly_total": [
            -126975,
            -127816,
            -123396,
            -107684,
            -457875,
            -178326,
            -136157,
            -118359,
            -143298,
            -140145,
            -165193,
            -167373
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -3058,
                -3290,
                -2778,
                -2761,
                -470571,
                -3976,
                -3513,
                -3976,
                -3015,
                -3223,
                -3030,
                -2939
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -2696,
                -2344,
                -2370,
                -2852,
                -2407,
                -58871,
                -3033,
                -2863,
                -2060,
                -2986,
                -2131,
                -2336
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -2614,
                -1983,
                -2100,
                -1915,
                -2498,
                -2611,
                -2730,
                -4090,
                -9589,
                -9828,
                -10571,
                -10912
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -16751,
                -16147,
                -20367,
                -22209,
                -16220,
                -20743,
                -21800,
                -21699,
                -26145,
                -24743,
                -21824,
                -28669
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -12879,
                -13553,
                -15227,
                -10359,
                -12300,
                -11471,
                -14804,
                -13491,
                -10922,
                -14496,
                -14660,
                -14209
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -701,
                -587,
                -756,
                -836,
                -886,
                -901,
                -926,
                -521,
                -2217,
                -2094,
                -2338,
                -1882
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -62387,
                -71789,
                -87637,
                -63488,
                -65164,
                -69559,
                -76724,
                -85286,
                -101081,
                -71576,
                -85675,
                -95629
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1113,
                -1486,
                -1361,
                -1319,
                -1368,
                -1164,
                -1441,
                -1357,
                -1293,
                -1232,
                -1602,
                -1343
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -7283,
                -7184,
                -6940,
                -6916,
                -6945,
                -6603,
                -6508,
                -6559,
                -6529,
                -7168,
                -7701,
                -6612
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -440,
                -21011,
                -491,
                -373,
                -449,
                -372,
                -428,
                -352,
                -352,
                -370,
                -453,
                -417
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -84,
                -84,
                -88,
                -94,
                -113,
                -96,
                -85,
                -86,
                -79,
                -88,
                -106,
                -109
              ]
            }
          }
        },
        "Cleanroom": {
          "monthly_total": [
            -20704,
            -14482,
            -23960,
            -18903,
            -60969,
            -31758,
            -22197,
            -25882,
            -30043,
            -21135,
            -22934,
            -31981
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                -35448,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -1118,
                -922,
                -1029,
                -1153,
                -1233,
                -990,
                -1114,
                -1127,
                -854,
                -1033,
                -860,
                -1052
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -967,
                -1075,
                -1002,
                -925,
                -903,
                -1160,
                -1076,
                -851,
                -905,
                -944,
                -831,
                -1022
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -303,
                -336,
                -353,
                -287,
                -309,
                -353,
                -371,
                -318,
                -253,
                -248,
                -356,
                -248
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -978,
                -802,
                -1131,
                -924,
                -898,
                -1025,
                -881,
                -858,
                -1020,
                -870,
                -785,
                -986
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -3149,
                -3408,
                -4228,
                -4399,
                -4160,
                -4426,
                -4174,
                -4388,
                -4013,
                -3667,
                -4013,
                -3483
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -616,
                -530,
                -805,
                -676,
                -850,
                -720,
                -696,
                -611,
                -672,
                -725,
                -763,
                -839
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -10289,
                -7169,
                -12044,
                -10592,
                -17660,
                -19442,
                -17053,
                -15325,
                -16199,
                -13646,
                -13575,
                -22385
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -233,
                -236,
                -262,
                -260,
                -267,
                -282,
                -276,
                -230,
                -302,
                -256,
                -266,
                -283
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1298,
                -1134,
                -1606,
                -1587,
                -1134,
                -1176,
                -1266,
                -1432,
                -1551,
                -1459,
                -1552,
                -1141
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -402,
                -347,
                -314,
                -387,
                -337,
                -437,
                -434,
                -349,
                -374,
                -417,
                -411,
                -327
              ]
            }
          }
        },
        "Supply Chain": {
          "monthly_total": [
            -38985,
            -34001,
            -48187,
            -44587,
            -91552,
            -34698,
            -32390,
            -36941,
            -35768,
            -41823,
            -32294,
            -42009
          ],
          "by_gl": {
            "15040": {
              "name": "Furniture",
              "monthly": [
                -294,
                -277,
                -304,
                -264,
                -308,
                -314,
                -272,
                -278,
                -251,
                -342,
                -348,
                -285
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -2096,
                -2299,
                -2776,
                -2004,
                -2769,
                -2161,
                -2398,
                -1883,
                -2415,
                -2675,
                -1857,
                -1972
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -160,
                -154,
                -168,
                -194,
                -222,
                -211,
                -160,
                -182,
                -223,
                -165,
                -154,
                -170
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -310,
                -274,
                -263,
                -244,
                -305,
                -359,
                -318,
                -273,
                -248,
                -279,
                -298,
                -290
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -17155,
                -15596,
                -23346,
                -17699,
                -12993,
                -18111,
                -16757,
                -13088,
                -20416,
                -19005,
                -12954,
                -16060
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -308,
                -240,
                -328,
                -246,
                -269,
                -421,
                -260,
                -310,
                -382,
                -291,
                -333,
                -387
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1846,
                -1626,
                -1692,
                -1541,
                -1734,
                -1432,
                -1876,
                -1876,
                -1547,
                -1754,
                -1594,
                -1961
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -50561,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -13594,
                -13170,
                -16186,
                -16691,
                -15770,
                -17425,
                -16343,
                -18089,
                -13470,
                -12372,
                -15524,
                -17877
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1208,
                -1351,
                -1099,
                -1232,
                -1195,
                -1039,
                -1041,
                -1316,
                -1137,
                -1327,
                -1259,
                -1079
              ]
            }
          }
        },
        "Facilities": {
          "monthly_total": [
            -151056,
            -133747,
            -198532,
            -194626,
            -172678,
            -183458,
            -170070,
            -210244,
            -217994,
            -207701,
            -172220,
            -174315
          ],
          "by_gl": {
            "15010": {
              "name": "Leasehold Improvements",
              "monthly": [
                -9129,
                -8505,
                -10055,
                -9290,
                -8575,
                -6997,
                -8036,
                -8607,
                -7169,
                -9406,
                -9049,
                -9717
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -3036,
                -3945,
                -3828,
                -3613,
                -2905,
                -3739,
                -4080,
                -2928,
                -3301,
                -3349,
                -3621,
                -4289
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -10366,
                -10299,
                -12554,
                -11709,
                -9602,
                -9641,
                -9584,
                -8951,
                -10778,
                -12637,
                -8705,
                -9402
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -7475,
                -5952,
                -6311,
                -6160,
                -5612,
                -6145,
                -6296,
                -7988,
                -6612,
                -7699,
                -6632,
                -5615
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -985,
                -1009,
                -986,
                -964,
                -1189,
                -830,
                -1156,
                -1252,
                -964,
                -1171,
                -939,
                -924
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -32018,
                -28455,
                -47854,
                -36529,
                -40137,
                -58552,
                -53523,
                -57728,
                -60783,
                -40472,
                -43020,
                -62208
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -974,
                -749,
                -884,
                -910,
                -939,
                -723,
                -867,
                -921,
                -964,
                -680,
                -780,
                -967
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -3720,
                -4363,
                -4664,
                -3947,
                -4852,
                -5089,
                -3651,
                -4013,
                -4222,
                -4513,
                -3994,
                -3975
              ]
            },
            "65010": {
              "name": "Rent",
              "monthly": [
                -69372,
                -85312,
                -86476,
                -92508,
                -94376,
                -87204,
                -96346,
                -90589,
                -82804,
                -93315,
                -94457,
                -74002
              ]
            },
            "65040": {
              "name": "Office Cleaning & Maintenance",
              "monthly": [
                -18838,
                -18379,
                -14330,
                -15265,
                -15610,
                -19221,
                -20311,
                -15880,
                -16451,
                -14468,
                -15464,
                -13687
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -334,
                -327,
                -311,
                -288,
                -411,
                -353,
                -324,
                -396,
                -338,
                -414,
                -330,
                -427
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -923,
                -579,
                -806,
                -758,
                -827,
                -739,
                -710,
                -855,
                -847,
                -755,
                -654,
                -897
              ]
            }
          }
        },
        "IT": {
          "monthly_total": [
            -23459,
            -31780,
            -34367,
            -41728,
            -35701,
            -28948,
            -26642,
            -29346,
            -32694,
            -29303,
            -29058,
            -34332
          ],
          "by_gl": {
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                -7494,
                -6504,
                -6019,
                -14003,
                -7591,
                -6925,
                -5637,
                -6680,
                -5564,
                -5370,
                -5793,
                -7667
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -8130,
                -8829,
                -9415,
                -7584,
                -7359,
                -10894,
                -7137,
                -7117,
                -8383,
                -7874,
                -9636,
                -11220
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -186,
                -130,
                -141,
                -181,
                -137,
                -152,
                -187,
                -189,
                -146,
                -173,
                -147,
                -165
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -725,
                -916,
                -697,
                -958,
                -718,
                -983,
                -955,
                -816,
                -758,
                -969,
                -938,
                -804
              ]
            },
            "65030": {
              "name": "Internet",
              "monthly": [
                -1121,
                -1235,
                -1374,
                -1237,
                -766,
                -783,
                -742,
                -673,
                -734,
                -937,
                -876,
                -681
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -11129,
                -9212,
                -11413,
                -22367,
                -27313,
                -10482,
                -10476,
                -8623,
                -10504,
                -12254,
                -8470,
                -10308
              ]
            },
            "66030": {
              "name": "IT Supplies & Small Equipments",
              "monthly": [
                -764,
                -488,
                -625,
                -594,
                -687,
                -676,
                -591,
                -691,
                -758,
                -767,
                -534,
                -656
              ]
            }
          }
        },
        "Design Control & Testing": {
          "monthly_total": [
            -67484,
            -62082,
            -84826,
            -63869,
            -250218,
            -250602,
            -163012,
            -67454,
            -76177,
            -67898,
            -77823,
            -104713
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                -167778,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3799,
                -3614,
                -3097,
                -3950,
                -5071,
                -11840,
                -9777,
                -4364,
                -4335,
                -6428,
                -5778,
                -6596
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -7579,
                -7309,
                -7908,
                -8831,
                -8743,
                -9549,
                -10027,
                -7745,
                -9275,
                -9392,
                -8983,
                -9635
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -2104,
                -2467,
                -2214,
                -1902,
                -2422,
                -1922,
                -2335,
                -2167,
                -2233,
                -2684,
                -2035,
                -1919
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -13511,
                -10444,
                -13545,
                -13542,
                -47298,
                -182356,
                -96888,
                -11601,
                -10543,
                -13925,
                -11075,
                -10067
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -39386,
                -37856,
                -46441,
                -37970,
                -37812,
                -47309,
                -28020,
                -38600,
                -48004,
                -35144,
                -46598,
                -59359
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -618,
                -734,
                -794,
                -696,
                -714,
                -757,
                -687,
                -758,
                -829,
                -631,
                -640,
                -615
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -3886,
                -3129,
                -3073,
                -3112,
                -3572,
                -4320,
                -3143,
                -3317,
                -3878,
                -3564,
                -3355,
                -4072
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Quality": {
          "monthly_total": [
            -12531,
            -81798,
            -22774,
            -14488,
            -17510,
            -34818,
            -29254,
            -38469,
            -43979,
            -31006,
            -38181,
            -33477
          ],
          "by_gl": {
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -179,
                -171,
                -201,
                -186,
                -2298,
                -2233,
                -2809,
                -2931,
                -2228,
                -2326,
                -3011,
                -3147
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -9939,
                -10947,
                -18138,
                -7922,
                -8092,
                -37678,
                -26408,
                -24289,
                -38812,
                -21144,
                -27169,
                -36171
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -457,
                -410,
                -451,
                -444,
                -390,
                -471,
                -415,
                -325,
                -463,
                -335,
                -377,
                -327
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1665,
                -2324,
                -2107,
                -1930,
                -2446,
                -1896,
                -2112,
                -2382,
                -2025,
                -1947,
                -2197,
                -2149
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -2246,
                -1765,
                -1747,
                -1670,
                -1660,
                -2027,
                -1574,
                -2205,
                -1658,
                -1708,
                -1615,
                -1863
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                -70019,
                0,
                0,
                -488,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Clinical & Regulatory": {
          "monthly_total": [
            -202337,
            -155627,
            -522479,
            -201648,
            -355250,
            -219187,
            -257563,
            -382302,
            -453034,
            -184716,
            -149638,
            -527276
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                -66794,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                0,
                0,
                -89074,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -9237
              ]
            },
            "52100": {
              "name": "Animal Testing",
              "monthly": [
                -118890,
                0,
                0,
                -60922,
                -91043,
                -48282,
                -89965,
                -330199,
                -246571,
                0,
                0,
                0
              ]
            },
            "52200": {
              "name": "Clinical Trial Costs",
              "monthly": [
                -13205,
                -24893,
                -34328,
                -22460,
                -267189,
                -26613,
                -30794,
                -32020,
                -60744,
                -60674,
                -73380,
                -226396
              ]
            },
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                0,
                0,
                -15131,
                0,
                0,
                0,
                0,
                -13946,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -61788,
                -48765,
                -48402,
                -43948,
                -55864,
                -56497,
                -60555,
                -77382,
                -75510,
                -73097,
                -77811,
                -78457
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -553,
                -459,
                -391,
                -383,
                -544,
                -508,
                -470,
                -399,
                -540,
                -479,
                -532,
                -522
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2512,
                -3054,
                -2586,
                -2538,
                -2262,
                -2178,
                -2732,
                -2362,
                -2358,
                -3026,
                -2336,
                -2983
              ]
            },
            "61055": {
              "name": "Payroll Taxes (US)",
              "monthly": [
                -1876,
                -2119,
                -2070,
                -1910,
                -2089,
                -1930,
                -1915,
                -2138,
                -1984,
                -2138,
                -1595,
                -1904
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -32641,
                -39487,
                -42364,
                -42414,
                -40813,
                -40901,
                -39179,
                -43429,
                -29151,
                -42492,
                -40395,
                -30621
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                -21052,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                0,
                0,
                -93287,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -11434
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -9460,
                -40943,
                -40991,
                -1705,
                -2219,
                -1924,
                -1845,
                -1700,
                -1789,
                -1962,
                -1782,
                -38643
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                0,
                0,
                -56674,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -21362
              ]
            },
            "67040": {
              "name": "Conferences",
              "monthly": [
                -2675,
                -1872,
                -1918,
                -1935,
                -2699,
                -2518,
                -2322,
                -2542,
                -2362,
                -2779,
                -1983,
                -2042
              ]
            }
          }
        },
        "Intellectual Property": {
          "monthly_total": [
            -93137,
            -93975,
            -70913,
            -56953,
            -95381,
            -106946,
            -77723,
            -74062,
            -100714,
            -226861,
            -80186,
            -77815
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -10492,
                -13868,
                -19062,
                -11022,
                -11698,
                -18702,
                -11377,
                -15030,
                -14441,
                -13234,
                -10657,
                -17472
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                0,
                0,
                0,
                -1089,
                -1265,
                -1032,
                -1168,
                -1024,
                -1213,
                -1017,
                -1175,
                -1079
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -299,
                -294,
                -307,
                -278,
                -228,
                -248,
                -268,
                -216,
                -259,
                -274,
                -220,
                -290
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1163,
                -1122,
                -1610,
                -1335,
                -1200,
                -1161,
                -1354,
                -1097,
                -1314,
                -1292,
                -1477,
                -1437
              ]
            },
            "63021": {
              "name": "Patent Management & Patent Attorneys",
              "monthly": [
                -75080,
                -90071,
                -40629,
                -61647,
                -73431,
                -74237,
                -70708,
                -62816,
                -64689,
                -235126,
                -59732,
                -69892
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -979,
                -824,
                -894,
                -1200,
                -1162,
                -14876,
                -968,
                -1199,
                -1206,
                -1253,
                -1103,
                -1255
              ]
            }
          }
        },
        "Finance & Legal": {
          "monthly_total": [
            -45791,
            -114155,
            -75789,
            -61817,
            -215976,
            -118940,
            -106110,
            -97064,
            -98147,
            -120222,
            -94730,
            -109254
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -15858,
                -28350,
                -32176,
                -29620,
                -21395,
                -34430,
                -22161,
                -21408,
                -29031,
                -22269,
                -27421,
                -32319
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -455,
                -543,
                -558,
                -563,
                -529,
                -409,
                -448,
                -444,
                -541,
                -402,
                -447,
                -578
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2994,
                -2809,
                -3026,
                -2707,
                -2266,
                -2432,
                -2460,
                -2474,
                -2639,
                -2534,
                -2188,
                -2290
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -1676,
                -1423,
                -1195,
                -1409,
                -42,
                -46,
                -52,
                -56,
                -46,
                -52,
                -54,
                -54
              ]
            },
            "63010": {
              "name": "Corporate Insurance",
              "monthly": [
                0,
                -79324,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -24826,
                -26515,
                -25548,
                -25800,
                -24916,
                -75654,
                -91233,
                -88192,
                -93477,
                -101098,
                -77567,
                -91974
              ]
            },
            "63030": {
              "name": "Audit & Tax",
              "monthly": [
                0,
                0,
                -23526,
                0,
                -98455,
                -28239,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -36620,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "68010": {
              "name": "Bank Charges",
              "monthly": [
                -713,
                -803,
                -722,
                -747,
                -904,
                -815,
                -745,
                -819,
                -719,
                -748,
                -920,
                -670
              ]
            }
          }
        },
        "People": {
          "monthly_total": [
            -67320,
            -63807,
            -49298,
            -38699,
            -57174,
            -48218,
            -56286,
            -37193,
            -43379,
            -44437,
            -39271,
            -42475
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -3625,
                -9416,
                -12521,
                -14743,
                -12998,
                -14095,
                -10598,
                -13757,
                -18012,
                -13686,
                -14234,
                -16461
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                0,
                0,
                0,
                -321,
                -283,
                -399,
                -386,
                -387,
                -357,
                -335,
                -274,
                -318
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -224,
                -214,
                -262,
                -230,
                -265,
                -224,
                -233,
                -252,
                -201,
                -252,
                -257,
                -272
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1239,
                -1428,
                -1230,
                -1230,
                -1005,
                -1146,
                -1318,
                -1224,
                -1012,
                -1218,
                -1295,
                -1008
              ]
            },
            "61060": {
              "name": "Employee Benefits - Health Plan",
              "monthly": [
                -11986,
                -9136,
                -13605,
                -14497,
                -13805,
                -9875,
                -11572,
                -10534,
                -8772,
                -10373,
                -8061,
                -10952
              ]
            },
            "61070": {
              "name": "Employee Benefits - Cellphone",
              "monthly": [
                -3252,
                -4249,
                -4569,
                -3710,
                -4087,
                -3714,
                -3704,
                -3533,
                -3999,
                -4120,
                -3216,
                -3571
              ]
            },
            "61080": {
              "name": "Employee Benefits - Gym",
              "monthly": [
                -1599,
                -1733,
                -1817,
                -1728,
                -1495,
                -1477,
                -1768,
                -1580,
                -1417,
                -1656,
                -1829,
                -1691
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1217,
                -1081,
                -1355,
                -1395,
                -1489,
                -1583,
                -1152,
                -1238,
                -1224,
                -1393,
                -1092,
                -1368
              ]
            },
            "64020": {
              "name": "Recruiting Fees",
              "monthly": [
                -37782,
                -25796,
                -2965,
                -3782,
                -2997,
                -3427,
                -3833,
                -3540,
                -2617,
                -2908,
                -3491,
                -3427
              ]
            },
            "64050": {
              "name": "Team Training",
              "monthly": [
                -520,
                -600,
                -598,
                -695,
                -578,
                -687,
                -6079,
                -685,
                -545,
                -666,
                -735,
                -547
              ]
            },
            "64060": {
              "name": "Team Events & Gifts",
              "monthly": [
                -5787,
                -1233,
                -1295,
                -3696,
                -1145,
                -1195,
                -1304,
                -1126,
                -1034,
                -3403,
                -993,
                -7698
              ]
            },
            "64070": {
              "name": "Team Meals",
              "monthly": [
                -2302,
                -2307,
                -2544,
                -2037,
                -2673,
                -2798,
                -2630,
                -3013,
                -2300,
                -2515,
                -2810,
                -2714
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1420,
                -1495,
                -1383,
                -502,
                -21473,
                -443,
                -568,
                -580,
                -457,
                -629,
                -441,
                -434
              ]
            },
            "66020": {
              "name": "Professional Licenses",
              "monthly": [
                -46,
                -53,
                -4931,
                -53,
                -38,
                -42,
                -45,
                -42,
                -48,
                -44,
                -50,
                -42
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1214,
                -1364,
                -1584,
                -1546,
                -1656,
                -1207,
                -1639,
                -1598,
                -1128,
                -1459,
                -1454,
                -1329
              ]
            }
          }
        },
        "Executive": {
          "monthly_total": [
            -36316,
            -31539,
            -53414,
            -51954,
            -52525,
            -45084,
            -33283,
            -45479,
            -54769,
            -37614,
            -32323,
            -41718
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -33342,
                -27607,
                -31111,
                -29859,
                -28210,
                -31302,
                -31964,
                -33788,
                -37177,
                -25245,
                -26060,
                -31860
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -482,
                -564,
                -658,
                -464,
                -543,
                -553,
                -461,
                -525,
                -476,
                -454,
                -575,
                -627
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -3410,
                -3465,
                -2637,
                -3499,
                -2496,
                -2766,
                -3433,
                -2682,
                -3472,
                -3268,
                -3406,
                -3203
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -151,
                -125,
                -117,
                -109,
                -152,
                -108,
                -126,
                -138,
                -137,
                -144,
                -113,
                -154
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -664,
                -636,
                -9858,
                -8606,
                -9447,
                -8607,
                -6683,
                -5980,
                -4793,
                -6758,
                -5657,
                -5131
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -2973,
                -2376,
                -2195,
                -2493,
                -2211,
                -2567,
                -2847,
                -3034,
                -2094,
                -2183,
                -2623,
                -2795
              ]
            }
          }
        },
        "Commercial": {
          "monthly_total": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "All company": {
          "monthly_total": [
            -1410833,
            -1333815,
            -1949959,
            -1340353,
            -3013943,
            -1836180,
            -3163747,
            -1990549,
            -2359324,
            -1772161,
            -1543581,
            -2174338
          ],
          "by_gl": {}
        }
      }
    },
    "2027": {
      "depts": {
        "Engineering": {
          "monthly_total": [
            -352756,
            -72411,
            -71002,
            -56006,
            -62174,
            -68982,
            -70973,
            -66773,
            -60763,
            -52850,
            -71573,
            -65548
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -298463,
                -55567,
                -62136,
                -52770,
                -42367,
                -71293,
                -58289,
                -65842,
                -49830,
                -41854,
                -64764,
                -48425
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1535,
                -1439,
                -1497,
                -1300,
                -1263,
                -1497,
                -1623,
                -1754,
                -1743,
                -1242,
                -1364,
                -1282
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -6305,
                -6898,
                -7142,
                -8035,
                -8752,
                -8427,
                -6771,
                -7187,
                -7013,
                -6497,
                -8170,
                -6487
              ]
            }
          }
        },
        "Electrical & Software": {
          "monthly_total": [
            -300444,
            -113779,
            -142353,
            -122860,
            -145696,
            -146284,
            -208063,
            -157068,
            -137296,
            -138887,
            -188175,
            -114385
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -3329,
                -4159,
                -4096,
                -3989,
                -3127,
                -3691,
                -4263,
                -3258,
                -4206,
                -3719,
                -3480,
                -3366
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -803,
                -729,
                -574,
                -572,
                -699,
                -774,
                -713,
                -674,
                -665,
                -604,
                -774,
                -765
              ]
            },
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51011": {
              "name": "Device Component",
              "monthly": [
                -603,
                -715,
                -645,
                -588,
                -547,
                -7893,
                -12750,
                -11298,
                -11270,
                -13758,
                -12037,
                -9748
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -4906,
                -5733,
                -5562,
                -5611,
                -5326,
                -4833,
                -5666,
                -6722,
                -5434,
                -6620,
                -6400,
                -5217
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -4039,
                -2898,
                -3615,
                -4153,
                -3291,
                -3862,
                -3012,
                -3422,
                -3256,
                -3495,
                -3952,
                -3113
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -811,
                -658,
                -705,
                -686,
                -724,
                -768,
                -667,
                -718,
                -594,
                -625,
                -620,
                -717
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1018,
                -843,
                -778,
                -1024,
                -964,
                -939,
                -910,
                -893,
                -854,
                -841,
                -846,
                -908
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -1142,
                -786,
                -1001,
                -779,
                -878,
                -1073,
                -1059,
                -1035,
                -1037,
                -958,
                -865,
                -998
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -118876,
                -1326,
                -1108,
                -1394,
                -1470,
                -1140,
                -54526,
                -1513,
                -1171,
                -1113,
                -1575,
                -1304
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -135066,
                -94190,
                -101743,
                -91599,
                -105289,
                -110538,
                -108195,
                -127398,
                -88143,
                -90572,
                -105790,
                -102138
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1753,
                -2081,
                -1878,
                -1982,
                -2025,
                -1506,
                -1596,
                -1637,
                -1734,
                -2005,
                -1714,
                -1561
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -9620,
                -10862,
                -11514,
                -10142,
                -10300,
                -8454,
                -8652,
                -9924,
                -9069,
                -10645,
                -7743,
                -8820
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -2111,
                -1768,
                -2335,
                -1896,
                -2310,
                -1873,
                -1867,
                -2335,
                -2029,
                -1724,
                -2266,
                -2173
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -359,
                -287,
                -460,
                -318,
                -356,
                -410,
                -377,
                -365,
                -339,
                -343,
                -349,
                -322
              ]
            }
          }
        },
        "Mechanical Design": {
          "monthly_total": [
            -304068,
            -194737,
            -249225,
            -235513,
            -303885,
            -209121,
            -1029025,
            -238554,
            -218742,
            -183820,
            -195550,
            -180177
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -4726,
                -5385,
                -4750,
                -5728,
                -4804,
                -5829,
                -5281,
                -5570,
                -5307,
                -5163,
                -5156,
                -5384
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -787,
                -648,
                -775,
                -593,
                -865,
                -798,
                -611,
                -605,
                -721,
                -606,
                -599,
                -870
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -101121,
                -91328,
                -98570,
                -105457,
                -74513,
                -104601,
                -1197952,
                -53017,
                -43468,
                -47763,
                -58250,
                -46663
              ]
            },
            "51025": {
              "name": "Fixturing & Jigs",
              "monthly": [
                -131,
                -150,
                -159,
                -159,
                -134,
                -151,
                -2267,
                -2781,
                -3315,
                -3396,
                -3058,
                -3648
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3952,
                -3464,
                -4477,
                -4318,
                -4414,
                -4097,
                -4613,
                -4242,
                -4619,
                -4195,
                -3583,
                -5132
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -12078,
                -12387,
                -13246,
                -10314,
                -9594,
                -10608,
                -10943,
                -12427,
                -13989,
                -11052,
                -10951,
                -13330
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -474,
                -526,
                -570,
                -558,
                -450,
                -563,
                -607,
                -621,
                -639,
                -460,
                -632,
                -476
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -182588,
                -106150,
                -111695,
                -120456,
                -108573,
                -148391,
                -83536,
                -132364,
                -108584,
                -113196,
                -151135,
                -108328
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1735,
                -2175,
                -2449,
                -2011,
                -2423,
                -1814,
                -2542,
                -2338,
                -1860,
                -2348,
                -1921,
                -2132
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -9507,
                -12765,
                -13213,
                -12180,
                -11978,
                -11901,
                -11064,
                -13273,
                -12192,
                -11913,
                -12551,
                -12644
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1595,
                -2058,
                -1710,
                -1885,
                -66734,
                -1941,
                -2219,
                -1948,
                -2050,
                -2218,
                -1964,
                -2273
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -411,
                -327,
                -333,
                -386,
                -347,
                -351,
                -346,
                -414,
                -450,
                -416,
                -365,
                -409
              ]
            }
          }
        },
        "Operations": {
          "monthly_total": [
            -242494,
            -170819,
            -54700,
            -15676,
            -16414,
            -167046,
            -203763,
            -174650,
            -169019,
            -201481,
            -161435,
            -219520
          ],
          "by_gl": {
            "51011": {
              "name": "Device Component",
              "monthly": [
                -172665,
                -147053,
                -26399,
                0,
                0,
                -118528,
                -161983,
                -168504,
                -168656,
                -176038,
                -189192,
                -196116
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -15986,
                -14448,
                -18206,
                -14967,
                -15182,
                -16427,
                -11872,
                -16695,
                -16016,
                -14907,
                -16499,
                -15703
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -256,
                -331,
                -233,
                -241,
                -234,
                -230,
                -271,
                -333,
                -250,
                -309,
                -264,
                -334
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1231,
                -1491,
                -1276,
                -1196,
                -1316,
                -1628,
                -1276,
                -1676,
                -1348,
                -1243,
                -1330,
                -1354
              ]
            }
          }
        },
        "Machine Shop & Metrology": {
          "monthly_total": [
            -548685,
            -151421,
            -173808,
            -148083,
            -161362,
            -187418,
            -136298,
            -180260,
            -155704,
            -182979,
            -172614,
            -152737
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -319486,
                -2855,
                -2325,
                -2425,
                -2544,
                -2788,
                -3442,
                -2556,
                -2721,
                -2871,
                -3262,
                -2583
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -2883,
                -2312,
                -3074,
                -2904,
                -2906,
                -2704,
                -2405,
                -2563,
                -3060,
                -2813,
                -3066,
                -2554
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -8322,
                -7480,
                -3772,
                -2601,
                -2397,
                -8975,
                -10378,
                -11025,
                -8851,
                -11112,
                -9099,
                -9359
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -21923,
                -20472,
                -23207,
                -17165,
                -19217,
                -20275,
                -27677,
                -21776,
                -22017,
                -19656,
                -18237,
                -26908
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -17170,
                -11857,
                -16925,
                -14003,
                -12846,
                -13033,
                -14376,
                -17537,
                -12891,
                -16194,
                -16880,
                -17254
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -2014,
                -1288,
                -442,
                -156,
                -115,
                -1369,
                -1986,
                -2246,
                -2016,
                -1716,
                -2133,
                -2266
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -134199,
                -92219,
                -91810,
                -69583,
                -88876,
                -92002,
                -102297,
                -125583,
                -95641,
                -96905,
                -91065,
                -85908
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1497,
                -1925,
                -1659,
                -2002,
                -1903,
                -1606,
                -2041,
                -1510,
                -1428,
                -2063,
                -1717,
                -1632
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -9848,
                -10575,
                -9131,
                -10195,
                -8236,
                -9178,
                -8018,
                -9232,
                -9953,
                -9877,
                -9355,
                -11020
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -434,
                -23316,
                -416,
                -421,
                -506,
                -460,
                -503,
                -492,
                -405,
                -381,
                -393,
                -426
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -88,
                -78,
                -116,
                -98,
                -109,
                -98,
                -91,
                -113,
                -95,
                -90,
                -80,
                -112
              ]
            }
          }
        },
        "Cleanroom": {
          "monthly_total": [
            -28249,
            -23457,
            -32435,
            -21886,
            -54634,
            -25474,
            -30808,
            -30146,
            -27005,
            -21626,
            -34114,
            -28152
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                -41856,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -1086,
                -1163,
                -1210,
                -1161,
                -1123,
                -1262,
                -1009,
                -1273,
                -919,
                -905,
                -1252,
                -1082
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -320,
                -281,
                -302,
                -299,
                -368,
                -277,
                -353,
                -289,
                -279,
                -276,
                -299,
                -376
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1038,
                -975,
                -1037,
                -925,
                -815,
                -1012,
                -1167,
                -887,
                -1105,
                -1057,
                -856,
                -860
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -3904,
                -4430,
                -3302,
                -4565,
                -4822,
                -3402,
                -4134,
                -4537,
                -3919,
                -3329,
                -4011,
                -3908
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -27205,
                -16367,
                -24703,
                -18774,
                -17519,
                -24220,
                -17005,
                -23748,
                -15012,
                -17357,
                -17857,
                -15380
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -397,
                -363,
                -331,
                -349,
                -384,
                -377,
                -386,
                -367,
                -390,
                -312,
                -394,
                -387
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2151,
                -1575,
                -1890,
                -1580,
                -1954,
                -2107,
                -1917,
                -1493,
                -1712,
                -1475,
                -1910,
                -1879
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -344,
                -407,
                -410,
                -413,
                -376,
                -451,
                -415,
                -383,
                -365,
                -350,
                -368,
                -377
              ]
            }
          }
        },
        "Supply Chain": {
          "monthly_total": [
            -53970,
            -39849,
            -37036,
            -46487,
            -93226,
            -45961,
            -45832,
            -37197,
            -36376,
            -36393,
            -51619,
            -44703
          ],
          "by_gl": {
            "15040": {
              "name": "Furniture",
              "monthly": [
                -278,
                -313,
                -357,
                -283,
                -359,
                -375,
                -315,
                -305,
                -263,
                -312,
                -285,
                -281
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -2397,
                -2644,
                -2718,
                -2760,
                -2459,
                -2325,
                -2617,
                -2638,
                -2806,
                -2985,
                -2490,
                -2222
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -236,
                -205,
                -225,
                -217,
                -200,
                -227,
                -192,
                -213,
                -177,
                -210,
                -220,
                -185
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -21980,
                -17686,
                -20564,
                -19554,
                -19633,
                -22704,
                -17719,
                -21096,
                -20931,
                -17207,
                -19277,
                -19676
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -565,
                -311,
                -363,
                -265,
                -380,
                -446,
                -268,
                -333,
                -343,
                -310,
                -406,
                -385
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1610,
                -2086,
                -1625,
                -2038,
                -2152,
                -1572,
                -1890,
                -1906,
                -1702,
                -1775,
                -2030,
                -1787
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -61445,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -16558,
                -13853,
                -16802,
                -13922,
                -16951,
                -17577,
                -14294,
                -19657,
                -19177,
                -19502,
                -18431,
                -18160
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1171,
                -1001,
                -1103,
                -1357,
                -1124,
                -1110,
                -1116,
                -1517,
                -1179,
                -1510,
                -1354,
                -1505
              ]
            }
          }
        },
        "Facilities": {
          "monthly_total": [
            -209001,
            -152404,
            -200634,
            -184382,
            -214620,
            -182746,
            -194812,
            -183621,
            -214644,
            -225016,
            -181076,
            -222988
          ],
          "by_gl": {
            "15010": {
              "name": "Leasehold Improvements",
              "monthly": [
                -7583,
                -8669,
                -7347,
                -7960,
                -7932,
                -6852,
                -7223,
                -9285,
                -7358,
                -9129,
                -7131,
                -7463
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -3775,
                -4055,
                -3667,
                -3126,
                -3746,
                -4391,
                -4448,
                -4076,
                -3507,
                -3577,
                -3157,
                -3186
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -9846,
                -10821,
                -11319,
                -11496,
                -9784,
                -9327,
                -12561,
                -11168,
                -11328,
                -9593,
                -10154,
                -11520
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -6201,
                -6265,
                -6155,
                -8469,
                -7577,
                -7727,
                -7274,
                -6741,
                -7815,
                -6177,
                -7521,
                -6658
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1210,
                -969,
                -1147,
                -1239,
                -1117,
                -1252,
                -978,
                -893,
                -1159,
                -1090,
                -921,
                -927
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -56208,
                -44559,
                -73019,
                -58361,
                -51889,
                -66437,
                -42218,
                -64815,
                -47900,
                -43529,
                -61293,
                -54398
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -974,
                -1110,
                -901,
                -1057,
                -1006,
                -1109,
                -932,
                -841,
                -934,
                -1137,
                -858,
                -1122
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -4847,
                -4361,
                -6067,
                -6162,
                -5414,
                -4357,
                -4433,
                -5124,
                -4187,
                -5083,
                -5867,
                -4283
              ]
            },
            "65010": {
              "name": "Rent",
              "monthly": [
                -78705,
                -95102,
                -75134,
                -90362,
                -97585,
                -77884,
                -103621,
                -95448,
                -74672,
                -87473,
                -99943,
                -92581
              ]
            },
            "65040": {
              "name": "Office Cleaning & Maintenance",
              "monthly": [
                -18159,
                -16868,
                -15491,
                -18214,
                -15127,
                -15596,
                -20822,
                -18684,
                -17749,
                -20191,
                -17496,
                -18324
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -394,
                -403,
                -361,
                -352,
                -453,
                -411,
                -322,
                -390,
                -379,
                -324,
                -306,
                -370
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -664,
                -715,
                -814,
                -832,
                -710,
                -712,
                -767,
                -919,
                -663,
                -881,
                -660,
                -662
              ]
            }
          }
        },
        "IT": {
          "monthly_total": [
            -41626,
            -25865,
            -35270,
            -33417,
            -51117,
            -29699,
            -31043,
            -26920,
            -25780,
            -32573,
            -33728,
            -29907
          ],
          "by_gl": {
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                -8545,
                -7400,
                -8058,
                -6379,
                -6953,
                -6885,
                -6101,
                -8325,
                -8167,
                -6186,
                -8057,
                -8083
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -12930,
                -9899,
                -12697,
                -8494,
                -7167,
                -11230,
                -8821,
                -11646,
                -10553,
                -7536,
                -11407,
                -9009
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -217,
                -192,
                -149,
                -150,
                -195,
                -177,
                -186,
                -177,
                -198,
                -193,
                -161,
                -192
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -893,
                -1073,
                -957,
                -1013,
                -834,
                -878,
                -1128,
                -853,
                -887,
                -768,
                -997,
                -1102
              ]
            },
            "65030": {
              "name": "Internet",
              "monthly": [
                -931,
                -656,
                -875,
                -839,
                -798,
                -878,
                -718,
                -745,
                -848,
                -650,
                -924,
                -758
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -9777,
                -12281,
                -10955,
                -15478,
                -29435,
                -9813,
                -12058,
                -11316,
                -10572,
                -13379,
                -10510,
                -9767
              ]
            },
            "66030": {
              "name": "IT Supplies & Small Equipments",
              "monthly": [
                -1119,
                -836,
                -761,
                -815,
                -794,
                -944,
                -804,
                -1109,
                -834,
                -865,
                -789,
                -1082
              ]
            }
          }
        },
        "Design Control & Testing": {
          "monthly_total": [
            -419366,
            -365169,
            -391726,
            -167333,
            -121973,
            -158489,
            -125086,
            -129444,
            -110146,
            -105160,
            -117118,
            -77746
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -7397,
                -8791,
                -9649,
                -6790,
                -8388,
                -5257,
                -6060,
                -5324,
                -3324,
                -3635,
                -4433,
                -3408
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -10711,
                -8719,
                -12568,
                -12789,
                -10119,
                -10045,
                -13707,
                -11628,
                -12773,
                -9511,
                -10585,
                -9834
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -2670,
                -2670,
                -2238,
                -1948,
                -2117,
                -2592,
                -2032,
                -2098,
                -2340,
                -2906,
                -2287,
                -2893
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -375305,
                -306853,
                -276628,
                -109026,
                -39574,
                -39653,
                -45523,
                -40160,
                -39149,
                -31416,
                -23089,
                -28814
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -64105,
                -40786,
                -53785,
                -54990,
                -40648,
                -59407,
                -39890,
                -57625,
                -45307,
                -42559,
                -66671,
                -50882
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1008,
                -1099,
                -1012,
                -755,
                -959,
                -862,
                -1051,
                -876,
                -1098,
                -1058,
                -1080,
                -905
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -5104,
                -5516,
                -4423,
                -5130,
                -4727,
                -4665,
                -3927,
                -4022,
                -5830,
                -4891,
                -4778,
                -3975
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -110,
                -94,
                -874,
                -3209,
                -3374,
                -3873,
                -3130,
                -125,
                -97,
                -114,
                -125,
                -136
              ]
            }
          }
        },
        "Quality": {
          "monthly_total": [
            -47119,
            -101632,
            -36650,
            -40066,
            -37611,
            -40385,
            -36626,
            -52691,
            -44602,
            -42301,
            -40387,
            -37495
          ],
          "by_gl": {
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -3248,
                -2730,
                -3228,
                -6457,
                -9587,
                -6873,
                -7473,
                -9161,
                -7388,
                -3732,
                -2986,
                -3283
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -35655,
                -25703,
                -35358,
                -33753,
                -25490,
                -37206,
                -24080,
                -35392,
                -32614,
                -31144,
                -41327,
                -24775
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -481,
                -555,
                -558,
                -481,
                -509,
                -637,
                -530,
                -540,
                -548,
                -570,
                -548,
                -639
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2791,
                -2935,
                -3372,
                -3582,
                -3203,
                -3383,
                -3409,
                -3016,
                -3598,
                -2638,
                -2981,
                -2773
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -2380,
                -2009,
                -1939,
                -2328,
                -1958,
                -1932,
                -1735,
                -1936,
                -1988,
                -1922,
                -1623,
                -2180
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                -53785,
                0,
                0,
                -632,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Clinical & Regulatory": {
          "monthly_total": [
            -585862,
            -330972,
            -430807,
            -319718,
            -293090,
            -359430,
            -193838,
            -174619,
            -232647,
            -221067,
            -297022,
            -1572280
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -7172,
                -8766,
                -9314,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "52100": {
              "name": "Animal Testing",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -12889,
                -16631,
                -12238
              ]
            },
            "52200": {
              "name": "Clinical Trial Costs",
              "monthly": [
                -126918,
                -144461,
                -117885,
                -141270,
                -141428,
                -116119,
                -57612,
                0,
                0,
                0,
                0,
                -897854
              ]
            },
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -3626,
                -3553,
                -3728,
                -4073,
                -2866,
                -4022,
                -3875,
                -4335,
                -3871,
                -5096,
                -4253,
                -7466
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -241904,
                -87998,
                -133085,
                -118939,
                -99356,
                -132428,
                -103480,
                -123047,
                -136414,
                -154308,
                -188250,
                -139972
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1485,
                -1979,
                -1795,
                -2030,
                -1447,
                -1585,
                -1464,
                -1451,
                -1800,
                -1621,
                -2011,
                -1699
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -10592,
                -8475,
                -10556,
                -10550,
                -8827,
                -8317,
                -10579,
                -9924,
                -9641,
                -7565,
                -9233,
                -10752
              ]
            },
            "61055": {
              "name": "Payroll Taxes (US)",
              "monthly": [
                -2031,
                -2339,
                -2029,
                -2603,
                -2319,
                -1999,
                -2649,
                -1883,
                -2247,
                -1983,
                -2666,
                -2498
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -33874,
                -34557,
                -38293,
                -42934,
                -35381,
                -33199,
                -44012,
                -37490,
                -38332,
                -34568,
                -45549,
                -41809
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -1500
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                -11652,
                0,
                0,
                0,
                0,
                0,
                -43863
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -12254,
                -10461,
                -11681,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -10514
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -29491,
                -26797,
                -29433,
                -2148,
                -1906,
                -2583,
                -2234,
                -2244,
                -2194,
                -2542,
                -2624,
                -27287
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -25148,
                -19030,
                -22107,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -4901
              ]
            },
            "67040": {
              "name": "Conferences",
              "monthly": [
                -2530,
                -2108,
                -2612,
                -2030,
                -2160,
                -2120,
                -2952,
                -2471,
                -2785,
                -2486,
                -2401,
                -2821
              ]
            }
          }
        },
        "Intellectual Property": {
          "monthly_total": [
            -80154,
            -71115,
            -64637,
            -62162,
            -78552,
            -75239,
            -61322,
            -80955,
            -80835,
            -59654,
            -83030,
            -65856
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -17545,
                -16637,
                -19310,
                -13345,
                -15672,
                -21154,
                -13040,
                -17090,
                -13361,
                -11717,
                -19053,
                -14935
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -1303,
                -1262,
                -1244,
                -1010,
                -1020,
                -1121,
                -1151,
                -1206,
                -1005,
                -1396,
                -1317,
                -1380
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -346,
                -244,
                -301,
                -311,
                -343,
                -346,
                -315,
                -314,
                -260,
                -290,
                -320,
                -240
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1328,
                -1680,
                -1497,
                -1544,
                -1590,
                -1368,
                -1737,
                -1764,
                -1318,
                -1402,
                -1544,
                -1680
              ]
            },
            "63021": {
              "name": "Patent Management & Patent Attorneys",
              "monthly": [
                -58787,
                -42276,
                -64522,
                -52432,
                -63509,
                -58251,
                -59320,
                -56864,
                -62149,
                -53248,
                -56393,
                -56102
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -945,
                -1206,
                -1374,
                -922,
                -1297,
                -13826,
                -1357,
                -1353,
                -1271,
                -975,
                -981,
                -952
              ]
            }
          }
        },
        "Finance & Legal": {
          "monthly_total": [
            -72445,
            -159170,
            -65297,
            -76070,
            -236292,
            -115309,
            -1307290,
            -70629,
            -78274,
            -82517,
            -82157,
            -74773
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -33432,
                -29379,
                -31972,
                -32822,
                -25061,
                -33803,
                -26654,
                -37924,
                -33161,
                -26857,
                -35720,
                -25012
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -598,
                -490,
                -547,
                -550,
                -642,
                -559,
                -555,
                -636,
                -636,
                -677,
                -474,
                -630
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -3385,
                -2750,
                -3403,
                -3076,
                -2958,
                -3207,
                -3394,
                -2626,
                -3151,
                -3054,
                -2686,
                -3501
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "63010": {
              "name": "Corporate Insurance",
              "monthly": [
                -6062,
                -80191,
                -4836,
                -6095,
                -6580,
                -6053,
                -4699,
                -5894,
                -5183,
                -6559,
                -6741,
                -5889
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -26079,
                -24053,
                -27570,
                -34362,
                -33099,
                -27215,
                -1103181,
                -27115,
                -27388,
                -27071,
                -32152,
                -34222
              ]
            },
            "63030": {
              "name": "Audit & Tax",
              "monthly": [
                0,
                0,
                0,
                0,
                -107504,
                -35773,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -35961,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "68010": {
              "name": "Bank Charges",
              "monthly": [
                -767,
                -917,
                -821,
                -982,
                -774,
                -939,
                -836,
                -836,
                -826,
                -817,
                -965,
                -876
              ]
            }
          }
        },
        "People": {
          "monthly_total": [
            -56818,
            -47667,
            -50034,
            -59426,
            -81733,
            -58934,
            -62712,
            -47010,
            -54060,
            -54030,
            -54604,
            -61478
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -22534,
                -14002,
                -15441,
                -12362,
                -13138,
                -18834,
                -13240,
                -16925,
                -12189,
                -16110,
                -19645,
                -15328
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -315,
                -361,
                -334,
                -294,
                -409,
                -281,
                -303,
                -393,
                -359,
                -338,
                -370,
                -359
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -225,
                -333,
                -289,
                -244,
                -261,
                -324,
                -336,
                -248,
                -257,
                -255,
                -243,
                -301
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1522,
                -1423,
                -1563,
                -1456,
                -1756,
                -1455,
                -1360,
                -1403,
                -1277,
                -1380,
                -1491,
                -1395
              ]
            },
            "61060": {
              "name": "Employee Benefits - Health Plan",
              "monthly": [
                -9804,
                -10545,
                -14307,
                -9846,
                -10195,
                -12340,
                -12587,
                -10254,
                -9385,
                -12814,
                -9709,
                -11045
              ]
            },
            "61070": {
              "name": "Employee Benefits - Cellphone",
              "monthly": [
                -4462,
                -4230,
                -4658,
                -3643,
                -3649,
                -3717,
                -3999,
                -4989,
                -4245,
                -4602,
                -4040,
                -3931
              ]
            },
            "61080": {
              "name": "Employee Benefits - Gym",
              "monthly": [
                -2256,
                -2216,
                -2315,
                -2059,
                -1979,
                -2355,
                -2451,
                -2197,
                -2073,
                -1860,
                -1944,
                -1727
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1270,
                -1169,
                -1559,
                -1411,
                -1613,
                -1494,
                -1736,
                -1255,
                -1615,
                -1569,
                -1378,
                -1358
              ]
            },
            "64020": {
              "name": "Recruiting Fees",
              "monthly": [
                -2980,
                -3340,
                -2930,
                -2898,
                -3920,
                -3659,
                -4052,
                -3477,
                -3200,
                -3672,
                -3622,
                -3210
              ]
            },
            "64050": {
              "name": "Team Training",
              "monthly": [
                -731,
                -658,
                -674,
                -750,
                -711,
                -728,
                -7922,
                -807,
                -691,
                -586,
                -771,
                -751
              ]
            },
            "64060": {
              "name": "Team Events & Gifts",
              "monthly": [
                -7323,
                -1186,
                -1539,
                -4663,
                -1196,
                -1067,
                -1437,
                -1296,
                -1134,
                -3638,
                -1121,
                -7508
              ]
            },
            "64070": {
              "name": "Team Meals",
              "monthly": [
                -5413,
                -4823,
                -4498,
                -5141,
                -3672,
                -4095,
                -5156,
                -4414,
                -3984,
                -5226,
                -4210,
                -4264
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -557,
                -521,
                -616,
                -487,
                -26333,
                -517,
                -617,
                -511,
                -483,
                -577,
                -573,
                -464
              ]
            },
            "66020": {
              "name": "Professional Licenses",
              "monthly": [
                -40,
                -54,
                -5114,
                -49,
                -52,
                -49,
                -43,
                -38,
                -55,
                -40,
                -52,
                -56
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1463,
                -1341,
                -1788,
                -1835,
                -1809,
                -1924,
                -1539,
                -1541,
                -1716,
                -1603,
                -1381,
                -1977
              ]
            }
          }
        },
        "Executive": {
          "monthly_total": [
            -268049,
            -50521,
            -53229,
            -48292,
            -46625,
            -55005,
            -45326,
            -60134,
            -44723,
            -46912,
            -53245,
            -47680
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -218827,
                -34642,
                -45319,
                -37431,
                -27510,
                -37072,
                -31574,
                -41490,
                -31067,
                -32454,
                -38068,
                -36466
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -912,
                -719,
                -937,
                -1067,
                -951,
                -765,
                -939,
                -806,
                -907,
                -1048,
                -897,
                -1038
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -4309,
                -5342,
                -3736,
                -4907,
                -5381,
                -5580,
                -5084,
                -5251,
                -4500,
                -5489,
                -4949,
                -4375
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -157,
                -139,
                -152,
                -134,
                -108,
                -130,
                -159,
                -140,
                -111,
                -139,
                -110,
                -143
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -7008,
                -6257,
                -5507,
                -5544,
                -6061,
                -5123,
                -6111,
                -5059,
                -6245,
                -5874,
                -5622,
                -5195
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -2922,
                -2750,
                -3138,
                -2352,
                -2356,
                -2795,
                -2521,
                -2899,
                -2954,
                -2213,
                -2572,
                -3009
              ]
            }
          }
        },
        "Commercial": {
          "monthly_total": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "All company": {
          "monthly_total": [
            -3155096,
            -2369710,
            -2439453,
            -1352183,
            -1758438,
            -2152156,
            -3260710,
            -1748277,
            -1482877,
            -1861075,
            -1874977,
            -2487899
          ],
          "by_gl": {}
        }
      }
    },
    "2028": {
      "depts": {
        "Engineering": {
          "monthly_total": [
            -421068,
            -73266,
            -58248,
            -61330,
            -79253,
            -68255,
            -76815,
            -87796,
            -58135,
            -92911,
            -59508,
            -64149
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -316197,
                -62938,
                -55299,
                -47931,
                -85176,
                -62714,
                -55004,
                -70367,
                -49779,
                -78540,
                -49830,
                -58945
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1583,
                -1574,
                -1299,
                -1855,
                -1602,
                -1890,
                -1858,
                -1601,
                -1708,
                -1536,
                -1645,
                -1400
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -7456,
                -10081,
                -9142,
                -9400,
                -7647,
                -10129,
                -9220,
                -6956,
                -7773,
                -9454,
                -8086,
                -7240
              ]
            }
          }
        },
        "Electrical & Software": {
          "monthly_total": [
            -215256,
            -166080,
            -127248,
            -131373,
            -162418,
            -177506,
            -155230,
            -204898,
            -153102,
            -190162,
            -139240,
            -189170
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -4084,
                -4296,
                -4671,
                -3927,
                -4863,
                -4259,
                -4299,
                -3416,
                -4785,
                -3547,
                -4285,
                -4741
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -715,
                -766,
                -792,
                -580,
                -629,
                -744,
                -848,
                -728,
                -720,
                -847,
                -651,
                -609
              ]
            },
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51011": {
              "name": "Device Component",
              "monthly": [
                -13147,
                -11450,
                -11462,
                -13157,
                -14528,
                -7554,
                -6699,
                -12279,
                -13988,
                -14255,
                -15847,
                -16368
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -5696,
                -4620,
                -4880,
                -5484,
                -4873,
                -6547,
                -4778,
                -6790,
                -4647,
                -4635,
                -4766,
                -6809
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3495,
                -4276,
                -3111,
                -3887,
                -3978,
                -4183,
                -4195,
                -3111,
                -3048,
                -3394,
                -3163,
                -4494
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -788,
                -863,
                -630,
                -630,
                -790,
                -878,
                -683,
                -679,
                -609,
                -732,
                -633,
                -635
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -980,
                -795,
                -895,
                -975,
                -1190,
                -969,
                -869,
                -941,
                -938,
                -970,
                -1152,
                -991
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -1037,
                -849,
                -902,
                -1012,
                -1108,
                -879,
                -887,
                -1162,
                -875,
                -873,
                -827,
                -1060
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -13433,
                -13379,
                -14087,
                -13040,
                -14987,
                -11516,
                -13571,
                -11348,
                -14425,
                -10410,
                -10359,
                -13756
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -178371,
                -132602,
                -103443,
                -117564,
                -134316,
                -115086,
                -117811,
                -148107,
                -81567,
                -116343,
                -101911,
                -90700
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1990,
                -1994,
                -1701,
                -2109,
                -2119,
                -2000,
                -1961,
                -1788,
                -2095,
                -1753,
                -1883,
                -2313
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -9480,
                -9309,
                -11100,
                -11681,
                -9292,
                -8982,
                -8625,
                -9712,
                -9545,
                -11176,
                -11219,
                -12486
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -2158,
                -2009,
                -2217,
                -2551,
                -2379,
                -2221,
                -2294,
                -2324,
                -2099,
                -2268,
                -2547,
                -2388
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -509,
                -326,
                -393,
                -340,
                -396,
                -423,
                -380,
                -405,
                -361,
                -346,
                -438,
                -401
              ]
            }
          }
        },
        "Mechanical Design": {
          "monthly_total": [
            -291287,
            -218245,
            -237543,
            -277285,
            -304141,
            -190669,
            -895686,
            -192944,
            -192549,
            -239124,
            -160805,
            -216354
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -4292,
                -3905,
                -4197,
                -5651,
                -5721,
                -5416,
                -5430,
                -6089,
                -4078,
                -4182,
                -5558,
                -5666
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -659,
                -612,
                -823,
                -849,
                -857,
                -601,
                -880,
                -896,
                -698,
                -847,
                -863,
                -715
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -59989,
                -42822,
                -57645,
                -68176,
                -45760,
                -54334,
                -654042,
                -51230,
                -33052,
                -30928,
                -27874,
                -33878
              ]
            },
            "51025": {
              "name": "Fixturing & Jigs",
              "monthly": [
                -3282,
                -3352,
                -2863,
                -3625,
                -3165,
                -3076,
                -3411,
                -2851,
                -2859,
                -3077,
                -3050,
                -3905
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -5209,
                -3670,
                -5429,
                -4071,
                -4535,
                -4394,
                -4106,
                -3833,
                -5142,
                -5229,
                -4850,
                -4396
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -14543,
                -15688,
                -14304,
                -12837,
                -13403,
                -12233,
                -15033,
                -16082,
                -12816,
                -11364,
                -14962,
                -15467
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -631,
                -519,
                -669,
                -648,
                -486,
                -559,
                -571,
                -490,
                -660,
                -648,
                -695,
                -686
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -144680,
                -146849,
                -122644,
                -98055,
                -145510,
                -117377,
                -95434,
                -146978,
                -131483,
                -164572,
                -128808,
                -124308
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2696,
                -2612,
                -2105,
                -2717,
                -2179,
                -2471,
                -2767,
                -2591,
                -2651,
                -2621,
                -1897,
                -2087
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -14624,
                -10987,
                -13282,
                -11518,
                -12136,
                -13186,
                -10809,
                -12519,
                -14569,
                -10546,
                -12458,
                -13725
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1893,
                -2310,
                -1966,
                -1894,
                -58719,
                -1990,
                -2285,
                -2087,
                -2283,
                -2384,
                -2191,
                -2462
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -396,
                -327,
                -395,
                -363,
                -472,
                -413,
                -435,
                -436,
                -346,
                -419,
                -332,
                -416
              ]
            }
          }
        },
        "Operations": {
          "monthly_total": [
            -203377,
            -167030,
            -206482,
            -169870,
            -167988,
            -239428,
            -372695,
            -475366,
            -310588,
            -367293,
            -319564,
            -381124
          ],
          "by_gl": {
            "51011": {
              "name": "Device Component",
              "monthly": [
                -153484,
                -168087,
                -205319,
                -186648,
                -203265,
                -211909,
                -384595,
                -541498,
                -354670,
                -375018,
                -350805,
                -358258
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -25770,
                -22200,
                -13826,
                -14698,
                -17834,
                -15877,
                -17375,
                -19958,
                -12418,
                -21337,
                -14176,
                -16756
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -374,
                -296,
                -359,
                -266,
                -279,
                -371,
                -303,
                -375,
                -284,
                -302,
                -296,
                -268
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1486,
                -1865,
                -1764,
                -1659,
                -1973,
                -1691,
                -1459,
                -1752,
                -1653,
                -1354,
                -1683,
                -1615
              ]
            }
          }
        },
        "Machine Shop & Metrology": {
          "monthly_total": [
            -804796,
            -195033,
            -162359,
            -180420,
            -165036,
            -142306,
            -191987,
            -155339,
            -200471,
            -177120,
            -188298,
            -183291
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -541421,
                -3923,
                -3961,
                -5294,
                -5338,
                -5104,
                -5064,
                -5422,
                -3955,
                -3758,
                -4268,
                -3992
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -2552,
                -3196,
                -3025,
                -2430,
                -3129,
                -2948,
                -2886,
                -2434,
                -3017,
                -2698,
                -2241,
                -2482
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -11965,
                -11252,
                -9267,
                -12658,
                -12809,
                -12433,
                -9634,
                -8295,
                -10498,
                -11619,
                -14907,
                -13185
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -20914,
                -21477,
                -20438,
                -20514,
                -21464,
                -27272,
                -24403,
                -20410,
                -20104,
                -28093,
                -26294,
                -21268
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -14319,
                -18270,
                -19662,
                -19094,
                -18674,
                -19211,
                -15810,
                -20508,
                -16487,
                -16844,
                -20063,
                -15474
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -2191,
                -1803,
                -1771,
                -2147,
                -2486,
                -1844,
                -2038,
                -1492,
                -5524,
                -4046,
                -4966,
                -4765
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -142489,
                -117331,
                -103653,
                -101273,
                -106214,
                -96522,
                -89026,
                -125353,
                -110241,
                -130664,
                -85920,
                -88936
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1833,
                -1667,
                -1848,
                -1822,
                -2168,
                -1753,
                -2284,
                -2041,
                -1876,
                -1590,
                -2065,
                -1737
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -9590,
                -9185,
                -10336,
                -12156,
                -8708,
                -10319,
                -8611,
                -9702,
                -11032,
                -9992,
                -8852,
                -9375
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -395,
                -18925,
                -543,
                -393,
                -573,
                -470,
                -493,
                -442,
                -383,
                -456,
                -418,
                -551
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -119,
                -101,
                -103,
                -104,
                -93,
                -89,
                -115,
                -99,
                -111,
                -114,
                -85,
                -108
              ]
            }
          }
        },
        "Cleanroom": {
          "monthly_total": [
            -99502,
            -74484,
            -80184,
            -39761,
            -94858,
            -27781,
            -28448,
            -43350,
            -39425,
            -40179,
            -37888,
            -28942
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -50210,
                -47351,
                -41622,
                -2820,
                -38060,
                -1114,
                -1307,
                -1060,
                -1364,
                -1118,
                -1306,
                -954
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -1951,
                -2706,
                -2802,
                -2042,
                -2237,
                -2381,
                -1987,
                -2875,
                -2314,
                -2536,
                -2392,
                -2177
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -291,
                -346,
                -293,
                -281,
                -318,
                -326,
                -343,
                -289,
                -356,
                -302,
                -346,
                -339
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1123,
                -921,
                -1256,
                -873,
                -1131,
                -1126,
                -998,
                -1082,
                -1120,
                -1216,
                -1110,
                -1221
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -6327,
                -7237,
                -8254,
                -7381,
                -8482,
                -6162,
                -8931,
                -8191,
                -8389,
                -8202,
                -7078,
                -8854
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -31606,
                -20765,
                -19124,
                -19629,
                -23523,
                -16743,
                -15497,
                -21646,
                -14965,
                -20422,
                -21222,
                -17713
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -433,
                -435,
                -420,
                -386,
                -386,
                -405,
                -348,
                -447,
                -434,
                -313,
                -345,
                -420
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1903,
                -2171,
                -2146,
                -2097,
                -2341,
                -1895,
                -2293,
                -1656,
                -2172,
                -1598,
                -2250,
                -1837
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -427,
                -361,
                -458,
                -495,
                -408,
                -337,
                -447,
                -400,
                -483,
                -366,
                -387,
                -437
              ]
            }
          }
        },
        "Supply Chain": {
          "monthly_total": [
            -64666,
            -48386,
            -41036,
            -51714,
            -91639,
            -40595,
            -48096,
            -48929,
            -43819,
            -61388,
            -57539,
            -42959
          ],
          "by_gl": {
            "15040": {
              "name": "Furniture",
              "monthly": [
                -297,
                -379,
                -335,
                -316,
                -326,
                -285,
                -347,
                -373,
                -350,
                -324,
                -307,
                -417
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3233,
                -3354,
                -2687,
                -2786,
                -2482,
                -2914,
                -3287,
                -3467,
                -2847,
                -2691,
                -3405,
                -2513
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -193,
                -194,
                -253,
                -240,
                -254,
                -197,
                -244,
                -180,
                -166,
                -203,
                -199,
                -242
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -180,
                -154,
                -149,
                -171,
                -152,
                -191,
                -188,
                -169,
                -210,
                -198,
                -157,
                -147
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -29262,
                -22212,
                -21856,
                -21473,
                -26926,
                -17097,
                -17141,
                -21871,
                -22425,
                -20593,
                -17290,
                -16302
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -595,
                -382,
                -315,
                -394,
                -433,
                -289,
                -303,
                -484,
                -309,
                -384,
                -355,
                -404
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2392,
                -2362,
                -1800,
                -2057,
                -2177,
                -1715,
                -1972,
                -2051,
                -2359,
                -2004,
                -1984,
                -1699
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -56712,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -20534,
                -24325,
                -26730,
                -21975,
                -20226,
                -19231,
                -18838,
                -24225,
                -21121,
                -24494,
                -23851,
                -18890
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1363,
                -1116,
                -1271,
                -1451,
                -1697,
                -1589,
                -1430,
                -1202,
                -1530,
                -1330,
                -1309,
                -1219
              ]
            }
          }
        },
        "Facilities": {
          "monthly_total": [
            -330087,
            -252494,
            -257921,
            -220535,
            -295605,
            -232796,
            -296037,
            -222581,
            -246667,
            -296980,
            -274422,
            -241036
          ],
          "by_gl": {
            "15010": {
              "name": "Leasehold Improvements",
              "monthly": [
                -30587,
                -27008,
                -33870,
                -32412,
                -37536,
                -34079,
                -41574,
                -37242,
                -36883,
                -30565,
                -35754,
                -30916
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -4161,
                -4176,
                -4547,
                -4411,
                -3815,
                -4494,
                -3870,
                -3946,
                -3650,
                -3205,
                -3739,
                -4304
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -9765,
                -12018,
                -9767,
                -10245,
                -10959,
                -13804,
                -12128,
                -13653,
                -10260,
                -9754,
                -12269,
                -11223
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -9056,
                -8034,
                -8282,
                -7428,
                -6989,
                -6766,
                -7982,
                -8030,
                -7408,
                -7632,
                -6092,
                -7533
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1160,
                -1194,
                -1319,
                -978,
                -1272,
                -1198,
                -1050,
                -1033,
                -946,
                -1363,
                -950,
                -1113
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -85075,
                -60522,
                -62486,
                -47169,
                -62405,
                -46739,
                -61928,
                -71081,
                -62986,
                -70561,
                -47811,
                -53376
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -923,
                -1299,
                -1166,
                -1107,
                -1278,
                -1169,
                -1188,
                -933,
                -1028,
                -1046,
                -885,
                -1043
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -6079,
                -4612,
                -5839,
                -5305,
                -5609,
                -4990,
                -6868,
                -5027,
                -5257,
                -5352,
                -5968,
                -5141
              ]
            },
            "65010": {
              "name": "Rent",
              "monthly": [
                -100825,
                -126585,
                -108247,
                -123338,
                -126876,
                -99381,
                -108998,
                -129537,
                -95144,
                -122373,
                -131624,
                -114902
              ]
            },
            "65040": {
              "name": "Office Cleaning & Maintenance",
              "monthly": [
                -21151,
                -14179,
                -18073,
                -17753,
                -21132,
                -16723,
                -19011,
                -16563,
                -16411,
                -17033,
                -18709,
                -16959
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -438,
                -323,
                -350,
                -459,
                -441,
                -418,
                -453,
                -327,
                -458,
                -466,
                -399,
                -460
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -909,
                -911,
                -773,
                -682,
                -721,
                -728,
                -731,
                -990,
                -870,
                -847,
                -870,
                -923
              ]
            }
          }
        },
        "IT": {
          "monthly_total": [
            -41551,
            -43924,
            -30676,
            -34453,
            -53924,
            -44264,
            -43923,
            -42974,
            -35983,
            -33425,
            -33360,
            -33384
          ],
          "by_gl": {
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                -11725,
                -11177,
                -10428,
                -11859,
                -9046,
                -10015,
                -11902,
                -11072,
                -8929,
                -12499,
                -11121,
                -9920
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -17496,
                -9840,
                -9914,
                -8319,
                -11814,
                -8610,
                -9661,
                -10901,
                -10512,
                -13315,
                -9811,
                -9803
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -206,
                -160,
                -172,
                -181,
                -226,
                -168,
                -224,
                -186,
                -168,
                -179,
                -175,
                -210
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1188,
                -1234,
                -971,
                -1114,
                -841,
                -850,
                -1033,
                -1021,
                -1131,
                -991,
                -1039,
                -1211
              ]
            },
            "65030": {
              "name": "Internet",
              "monthly": [
                -885,
                -770,
                -919,
                -955,
                -885,
                -662,
                -906,
                -935,
                -756,
                -734,
                -735,
                -1004
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -13331,
                -15199,
                -14660,
                -18237,
                -26749,
                -10970,
                -15741,
                -15357,
                -15710,
                -15462,
                -13157,
                -12498
              ]
            },
            "66030": {
              "name": "IT Supplies & Small Equipments",
              "monthly": [
                -1660,
                -1449,
                -1417,
                -1242,
                -1644,
                -1635,
                -1613,
                -1661,
                -1570,
                -1691,
                -1233,
                -1708
              ]
            }
          }
        },
        "Design Control & Testing": {
          "monthly_total": [
            -152923,
            -160283,
            -131412,
            -130013,
            -194149,
            -147612,
            -125501,
            -152343,
            -153307,
            -138080,
            -152278,
            -159560
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -4494,
                -3479,
                -3103,
                -3133,
                -3245,
                -3908,
                -3128,
                -4245,
                -4254,
                -3699,
                -3331,
                -4405
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -2946,
                -2108,
                -2647,
                -2633,
                -2186,
                -2065,
                -2161,
                -2731,
                -2579,
                -2843,
                -2336,
                -2980
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -75645,
                -75673,
                -78418,
                -89154,
                -73946,
                -76481,
                -99967,
                -87621,
                -68568,
                -82515,
                -63071,
                -91455
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -72089,
                -74467,
                -60310,
                -46407,
                -76130,
                -41971,
                -52945,
                -71975,
                -50947,
                -62939,
                -51451,
                -58438
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -995,
                -1177,
                -972,
                -994,
                -972,
                -1188,
                -1166,
                -1145,
                -840,
                -1192,
                -1168,
                -895
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -5274,
                -6230,
                -5018,
                -5795,
                -5492,
                -5832,
                -6265,
                -4816,
                -5962,
                -6334,
                -5834,
                -4657
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Quality": {
          "monthly_total": [
            -56258,
            -95389,
            -42597,
            -44580,
            -39665,
            -33995,
            -47674,
            -49096,
            -36674,
            -49415,
            -48470,
            -43722
          ],
          "by_gl": {
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -3573,
                -2747,
                -3221,
                -2946,
                -2809,
                -3739,
                -3354,
                -3478,
                -3695,
                -4073,
                -2986,
                -3054
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -55280,
                -42539,
                -34760,
                -35906,
                -41457,
                -37638,
                -29596,
                -33290,
                -29864,
                -45916,
                -30540,
                -32797
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -639,
                -528,
                -770,
                -667,
                -708,
                -588,
                -538,
                -670,
                -724,
                -659,
                -703,
                -746
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2896,
                -3668,
                -3010,
                -3270,
                -3975,
                -3755,
                -2813,
                -3267,
                -4010,
                -3696,
                -3713,
                -3587
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -2176,
                -1801,
                -2325,
                -2027,
                -2271,
                -2128,
                -2244,
                -1828,
                -2168,
                -1978,
                -2349,
                -1769
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                -66105,
                0,
                0,
                -736,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Clinical & Regulatory": {
          "monthly_total": [
            -1284412,
            -945815,
            -726565,
            -715602,
            -855162,
            -748721,
            -960409,
            -851872,
            -996534,
            -882601,
            -905482,
            -991995
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "52100": {
              "name": "Animal Testing",
              "monthly": [
                -12469,
                -13692,
                -14782,
                -13347,
                -17462,
                -12856,
                -15426,
                -14310,
                -11567,
                -14621,
                -12407,
                -12412
              ]
            },
            "52200": {
              "name": "Clinical Trial Costs",
              "monthly": [
                -488181,
                -555512,
                -434317,
                -496929,
                -565398,
                -470935,
                -455962,
                -488184,
                -425169,
                -438827,
                -475083,
                -473695
              ]
            },
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -3579,
                -3254,
                -3579,
                -3097,
                -3231,
                -2861,
                -2904,
                -3541,
                -3246,
                -3737,
                -3776,
                -3928
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -539903,
                -262824,
                -194660,
                -201245,
                -261732,
                -259042,
                -228076,
                -277990,
                -225693,
                -266543,
                -240532,
                -194891
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -3797,
                -3811,
                -3268,
                -4401,
                -3383,
                -3735,
                -3329,
                -3200,
                -3164,
                -3929,
                -3247,
                -4416
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -16671,
                -18871,
                -19189,
                -22121,
                -21355,
                -23034,
                -17752,
                -18112,
                -17485,
                -18416,
                -23261,
                -18316
              ]
            },
            "61055": {
              "name": "Payroll Taxes (US)",
              "monthly": [
                -2679,
                -2570,
                -2893,
                -2664,
                -2981,
                -2503,
                -2976,
                -2185,
                -3058,
                -2201,
                -2877,
                -2689
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -50475,
                -52768,
                -43107,
                -56119,
                -59674,
                -57089,
                -54993,
                -53546,
                -47990,
                -55542,
                -44172,
                -48138
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1796,
                -1740,
                -1516,
                -1913,
                -1926,
                -1825,
                -1939,
                -1648,
                -1981,
                -1985,
                -1686,
                -1560
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -18112,
                -16605,
                -15938,
                -19422,
                -21243,
                -14880,
                -19352,
                -20917,
                -20000,
                -20199,
                -18660,
                -20060
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -12962,
                -11066,
                -10953,
                -9435,
                -10669,
                -12185,
                -10847,
                -10206,
                -12117,
                -9522,
                -9981,
                -9303
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -28142,
                -26781,
                -24214,
                -26342,
                -23384,
                -22958,
                -23124,
                -30538,
                -28379,
                -23514,
                -25829,
                -23566
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -5465,
                -5662,
                -5048,
                -6373,
                -6103,
                -5969,
                -5416,
                -5630,
                -5796,
                -4906,
                -5388,
                -4600
              ]
            },
            "67040": {
              "name": "Conferences",
              "monthly": [
                -2099,
                -2591,
                -2810,
                -2918,
                -2292,
                -2560,
                -2752,
                -2112,
                -2205,
                -2858,
                -2000,
                -2838
              ]
            }
          }
        },
        "Intellectual Property": {
          "monthly_total": [
            -118445,
            -98664,
            -92650,
            -87807,
            -112233,
            -114490,
            -104332,
            -114045,
            -91268,
            -105700,
            -90371,
            -79469
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -26040,
                -22233,
                -13466,
                -18178,
                -18987,
                -13277,
                -17413,
                -21413,
                -14249,
                -21103,
                -17949,
                -18939
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -1283,
                -900,
                -1257,
                -1004,
                -1077,
                -958,
                -1248,
                -1403,
                -1053,
                -1047,
                -1334,
                -1152
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -280,
                -331,
                -315,
                -321,
                -263,
                -282,
                -378,
                -292,
                -360,
                -267,
                -317,
                -281
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1380,
                -1877,
                -1398,
                -1822,
                -1975,
                -1813,
                -1958,
                -1578,
                -2019,
                -1846,
                -1958,
                -1746
              ]
            },
            "63021": {
              "name": "Patent Management & Patent Attorneys",
              "monthly": [
                -75183,
                -79651,
                -64655,
                -67771,
                -80559,
                -76170,
                -85648,
                -109529,
                -107249,
                -64697,
                -51055,
                -52769
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1380,
                -1137,
                -1312,
                -1378,
                -1362,
                -16185,
                -1393,
                -1101,
                -1105,
                -995,
                -1209,
                -1153
              ]
            }
          }
        },
        "Finance & Legal": {
          "monthly_total": [
            -67138,
            -170109,
            -53153,
            -55167,
            -239795,
            -120573,
            -51393,
            -63245,
            -65536,
            -64816,
            -69872,
            -58298
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -54552,
                -40092,
                -31001,
                -24956,
                -31046,
                -34604,
                -31093,
                -42744,
                -31275,
                -39118,
                -28411,
                -29700
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -503,
                -621,
                -660,
                -614,
                -636,
                -504,
                -681,
                -699,
                -730,
                -546,
                -605,
                -750
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2671,
                -3440,
                -2907,
                -2675,
                -3745,
                -2624,
                -2733,
                -3308,
                -2931,
                -3518,
                -3625,
                -3646
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "63010": {
              "name": "Corporate Insurance",
              "monthly": [
                -6525,
                -86980,
                -5390,
                -5983,
                -5199,
                -5642,
                -5841,
                -6171,
                -6401,
                -6371,
                -6468,
                -6933
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -26034,
                -18800,
                -25567,
                -22250,
                -22540,
                -17612,
                -22354,
                -25505,
                -24517,
                -21840,
                -18343,
                -20227
              ]
            },
            "63030": {
              "name": "Audit & Tax",
              "monthly": [
                0,
                0,
                0,
                0,
                -83982,
                -45435,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -38799,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "68010": {
              "name": "Bank Charges",
              "monthly": [
                -1079,
                -840,
                -1266,
                -1092,
                -965,
                -996,
                -1053,
                -1077,
                -1083,
                -911,
                -1070,
                -1172
              ]
            }
          }
        },
        "People": {
          "monthly_total": [
            -55906,
            -48749,
            -55966,
            -62064,
            -104863,
            -60762,
            -62350,
            -53604,
            -47383,
            -57087,
            -45987,
            -57187
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -25271,
                -21298,
                -12298,
                -17878,
                -15581,
                -15178,
                -14143,
                -19287,
                -13476,
                -22339,
                -12855,
                -16037
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -354,
                -285,
                -336,
                -294,
                -290,
                -352,
                -334,
                -372,
                -370,
                -376,
                -376,
                -373
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -332,
                -329,
                -309,
                -310,
                -307,
                -282,
                -252,
                -351,
                -252,
                -268,
                -262,
                -353
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1711,
                -1438,
                -1704,
                -1451,
                -1840,
                -1860,
                -1422,
                -1310,
                -1929,
                -1937,
                -1834,
                -1903
              ]
            },
            "61060": {
              "name": "Employee Benefits - Health Plan",
              "monthly": [
                -17938,
                -13454,
                -16765,
                -16786,
                -17959,
                -12227,
                -15529,
                -16234,
                -14800,
                -13871,
                -16936,
                -16718
              ]
            },
            "61070": {
              "name": "Employee Benefits - Cellphone",
              "monthly": [
                -5193,
                -4262,
                -3966,
                -3939,
                -4108,
                -4521,
                -4515,
                -3946,
                -4839,
                -5034,
                -4373,
                -4799
              ]
            },
            "61080": {
              "name": "Employee Benefits - Gym",
              "monthly": [
                -2602,
                -2272,
                -2516,
                -2389,
                -3108,
                -2700,
                -2399,
                -2564,
                -2619,
                -2482,
                -2581,
                -2324
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1655,
                -1256,
                -1457,
                -1605,
                -1451,
                -1261,
                -1268,
                -1819,
                -1550,
                -1529,
                -1473,
                -1291
              ]
            },
            "64020": {
              "name": "Recruiting Fees",
              "monthly": [
                -3340,
                -3327,
                -3099,
                -3217,
                -3639,
                -3640,
                -3282,
                -3709,
                -3201,
                -3451,
                -4014,
                -3743
              ]
            },
            "64050": {
              "name": "Team Training",
              "monthly": [
                -646,
                -582,
                -740,
                -744,
                -680,
                -741,
                -9585,
                -750,
                -741,
                -633,
                -724,
                -716
              ]
            },
            "64060": {
              "name": "Team Events & Gifts",
              "monthly": [
                -7361,
                -1522,
                -1630,
                -7233,
                -1463,
                -1571,
                -1889,
                -1911,
                -1302,
                -3415,
                -1828,
                -10753
              ]
            },
            "64070": {
              "name": "Team Meals",
              "monthly": [
                -5439,
                -3707,
                -5306,
                -4711,
                -3962,
                -5209,
                -4479,
                -5654,
                -4348,
                -5018,
                -5158,
                -4351
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -612,
                -664,
                -676,
                -653,
                -56644,
                -594,
                -591,
                -656,
                -604,
                -552,
                -637,
                -565
              ]
            },
            "66020": {
              "name": "Professional Licenses",
              "monthly": [
                -46,
                -40,
                -6387,
                -40,
                -47,
                -57,
                -47,
                -57,
                -45,
                -43,
                -54,
                -41
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -2170,
                -2287,
                -2274,
                -2042,
                -2010,
                -2426,
                -2506,
                -2253,
                -1725,
                -1683,
                -2008,
                -1715
              ]
            }
          }
        },
        "Executive": {
          "monthly_total": [
            -231863,
            -82067,
            -102221,
            -96254,
            -136663,
            -106053,
            -137041,
            -162742,
            -178293,
            -202788,
            -207434,
            -215617
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -216317,
                -60543,
                -78373,
                -79488,
                -113225,
                -101957,
                -125122,
                -137401,
                -125490,
                -185022,
                -171145,
                -160800
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2554,
                -2491,
                -2506,
                -2449,
                -2056,
                -2605,
                -2555,
                -2171,
                -2500,
                -1952,
                -2370,
                -2823
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -12568,
                -12635,
                -11387,
                -12383,
                -14365,
                -10753,
                -13176,
                -10848,
                -13207,
                -11529,
                -12996,
                -12046
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -153,
                -131,
                -128,
                -160,
                -153,
                -131,
                -149,
                -117,
                -153,
                -118,
                -115,
                -114
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -6713,
                -5294,
                -5106,
                -6614,
                -7261,
                -4924,
                -7090,
                -6229,
                -5546,
                -5571,
                -5522,
                -7088
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -2549,
                -2738,
                -2832,
                -2634,
                -2916,
                -2629,
                -2810,
                -2295,
                -2962,
                -3219,
                -2296,
                -3077
              ]
            }
          }
        },
        "Commercial": {
          "monthly_total": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "All company": {
          "monthly_total": [
            -4703332,
            -3144483,
            -2347952,
            -2623446,
            -3530942,
            -2984627,
            -3664239,
            -2548111,
            -2520187,
            -2611449,
            -2814859,
            -2865209
          ],
          "by_gl": {}
        }
      }
    },
    "2029": {
      "depts": {
        "Engineering": {
          "monthly_total": [
            -373698,
            -61173,
            -71902,
            -64992,
            -84493,
            -82906,
            -77381,
            -66871,
            -85622,
            -73211,
            -86367,
            -70203
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -367636,
                -67914,
                -57465,
                -52504,
                -83978,
                -55725,
                -75608,
                -73353,
                -53793,
                -63582,
                -51981,
                -52913
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2099,
                -2123,
                -1661,
                -1617,
                -1595,
                -1587,
                -1624,
                -1614,
                -1759,
                -1542,
                -2078,
                -1596
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -9998,
                -8410,
                -10098,
                -8015,
                -10655,
                -10634,
                -9764,
                -10422,
                -8013,
                -9445,
                -8582,
                -8113
              ]
            }
          }
        },
        "Electrical & Software": {
          "monthly_total": [
            -221935,
            -171781,
            -174441,
            -150548,
            -199903,
            -141383,
            -188314,
            -155591,
            -202985,
            -214842,
            -141470,
            -198095
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -4915,
                -3828,
                -4444,
                -4871,
                -5179,
                -4724,
                -5272,
                -5532,
                -3894,
                -3876,
                -3657,
                -4029
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -708,
                -614,
                -648,
                -793,
                -805,
                -740,
                -704,
                -660,
                -609,
                -751,
                -645,
                -870
              ]
            },
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51011": {
              "name": "Device Component",
              "monthly": [
                -15577,
                -13711,
                -13622,
                -14010,
                -13669,
                -12511,
                -12478,
                -16080,
                -16671,
                -13740,
                -12153,
                -14363
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -4845,
                -5078,
                -6022,
                -5606,
                -6850,
                -5926,
                -6451,
                -5859,
                -4720,
                -6683,
                -6657,
                -5765
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3635,
                -3543,
                -4163,
                -4685,
                -3386,
                -4585,
                -3404,
                -4655,
                -3903,
                -4298,
                -3679,
                -3323
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -937,
                -764,
                -710,
                -668,
                -937,
                -785,
                -786,
                -702,
                -704,
                -803,
                -917,
                -1002
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1195,
                -1151,
                -958,
                -978,
                -1072,
                -1223,
                -1149,
                -1210,
                -1192,
                -1217,
                -1209,
                -879
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -935,
                -931,
                -1063,
                -865,
                -911,
                -1109,
                -1056,
                -1071,
                -1136,
                -961,
                -1136,
                -905
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -12947,
                -9793,
                -11557,
                -14323,
                -14351,
                -13639,
                -14477,
                -11423,
                -11491,
                -10828,
                -12707,
                -14765
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -173636,
                -103127,
                -126639,
                -103739,
                -145609,
                -98189,
                -114758,
                -132259,
                -127856,
                -131491,
                -111815,
                -91201
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2608,
                -1839,
                -2263,
                -2082,
                -2292,
                -2442,
                -1893,
                -2308,
                -2228,
                -2289,
                -2088,
                -1855
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -13433,
                -13869,
                -10029,
                -10598,
                -12488,
                -10952,
                -10505,
                -10857,
                -12767,
                -10384,
                -12245,
                -12931
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -2573,
                -2027,
                -3095,
                -2573,
                -2191,
                -2851,
                -2923,
                -2957,
                -2825,
                -2717,
                -2879,
                -2374
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -529,
                -368,
                -549,
                -436,
                -401,
                -540,
                -445,
                -506,
                -533,
                -431,
                -505,
                -454
              ]
            }
          }
        },
        "Mechanical Design": {
          "monthly_total": [
            -247390,
            -171347,
            -179713,
            -197366,
            -329430,
            -159671,
            -931166,
            -221783,
            -194529,
            -201821,
            -176787,
            -179368
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -6036,
                -5083,
                -6131,
                -4652,
                -5996,
                -4165,
                -4144,
                -4936,
                -5492,
                -5924,
                -4060,
                -4304
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -873,
                -572,
                -860,
                -725,
                -650,
                -829,
                -746,
                -699,
                -628,
                -895,
                -812,
                -777
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -19670,
                -14961,
                -21258,
                -50751,
                -23242,
                -19501,
                -477347,
                -17561,
                -19595,
                -17335,
                -18710,
                -23057
              ]
            },
            "51025": {
              "name": "Fixturing & Jigs",
              "monthly": [
                -3535,
                -3325,
                -3963,
                -3326,
                -3808,
                -2809,
                -3697,
                -3210,
                -3942,
                -3144,
                -3192,
                -3830
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -4290,
                -5038,
                -4394,
                -4390,
                -4144,
                -4442,
                -5456,
                -3999,
                -4355,
                -4219,
                -5430,
                -4094
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -13096,
                -11032,
                -12903,
                -11640,
                -14939,
                -14096,
                -12932,
                -15518,
                -15839,
                -15824,
                -13449,
                -14310
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -692,
                -658,
                -596,
                -581,
                -635,
                -570,
                -736,
                -767,
                -518,
                -697,
                -705,
                -604
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -213554,
                -124866,
                -108502,
                -109680,
                -166789,
                -110700,
                -163431,
                -101969,
                -123864,
                -139721,
                -120485,
                -141321
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2320,
                -2509,
                -3011,
                -2910,
                -2319,
                -2627,
                -3053,
                -3000,
                -2178,
                -2149,
                -3071,
                -2147
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -15231,
                -14981,
                -15114,
                -11229,
                -14432,
                -12193,
                -13025,
                -15475,
                -12215,
                -11895,
                -13628,
                -11568
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1980,
                -2116,
                -2476,
                -2395,
                -60664,
                -2058,
                -2601,
                -1908,
                -2091,
                -2219,
                -2035,
                -2552
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -492,
                -338,
                -342,
                -476,
                -343,
                -341,
                -496,
                -478,
                -472,
                -486,
                -371,
                -433
              ]
            }
          }
        },
        "Operations": {
          "monthly_total": [
            -402808,
            -366373,
            -388389,
            -419443,
            -387621,
            -431392,
            -466019,
            -433737,
            -324317,
            -424734,
            -333603,
            -427740
          ],
          "by_gl": {
            "51011": {
              "name": "Device Component",
              "monthly": [
                -398941,
                -286437,
                -400715,
                -436265,
                -365908,
                -365555,
                -333335,
                -349525,
                -370145,
                -403417,
                -338935,
                -312882
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -30460,
                -16905,
                -13867,
                -15976,
                -18417,
                -18618,
                -20965,
                -16248,
                -14431,
                -23486,
                -16377,
                -19406
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -410,
                -404,
                -327,
                -340,
                -280,
                -301,
                -374,
                -331,
                -363,
                -307,
                -408,
                -354
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1796,
                -1553,
                -1769,
                -2085,
                -1644,
                -2166,
                -1928,
                -1843,
                -2077,
                -1493,
                -1564,
                -1873
              ]
            }
          }
        },
        "Machine Shop & Metrology": {
          "monthly_total": [
            -320598,
            -239163,
            -178528,
            -222130,
            -220629,
            -219239,
            -224722,
            -247862,
            -219218,
            -217174,
            -191753,
            -212034
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -24213,
                -19803,
                -23879,
                -22532,
                -19249,
                -27158,
                -21046,
                -21852,
                -26366,
                -19688,
                -18757,
                -28028
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -3375,
                -2996,
                -2559,
                -2920,
                -2763,
                -3320,
                -2473,
                -3016,
                -2437,
                -3205,
                -3009,
                -2831
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -12229,
                -10749,
                -11193,
                -11278,
                -11603,
                -14812,
                -12219,
                -14199,
                -11628,
                -11980,
                -14246,
                -12499
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -24137,
                -17843,
                -28177,
                -26146,
                -28462,
                -25935,
                -29151,
                -28988,
                -20939,
                -21355,
                -25909,
                -21263
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -23073,
                -19262,
                -19997,
                -17619,
                -18183,
                -17884,
                -17461,
                -18973,
                -17076,
                -22189,
                -18034,
                -16738
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -5303,
                -4836,
                -5354,
                -4322,
                -5025,
                -5887,
                -5324,
                -4371,
                -4320,
                -4450,
                -5445,
                -6216
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -146343,
                -88829,
                -122339,
                -104318,
                -150208,
                -85117,
                -122735,
                -121869,
                -120844,
                -112292,
                -96438,
                -102873
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2389,
                -2312,
                -2066,
                -2076,
                -2045,
                -2341,
                -1843,
                -2305,
                -2384,
                -2567,
                -2503,
                -1816
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -13069,
                -9037,
                -12602,
                -11651,
                -12233,
                -12871,
                -11351,
                -9574,
                -10993,
                -9235,
                -10497,
                -10860
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -481,
                -21440,
                -607,
                -601,
                -554,
                -582,
                -546,
                -571,
                -559,
                -425,
                -488,
                -520
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -116,
                -120,
                -93,
                -101,
                -129,
                -123,
                -122,
                -119,
                -121,
                -105,
                -129,
                -101
              ]
            }
          }
        },
        "Cleanroom": {
          "monthly_total": [
            -53485,
            -31626,
            -43815,
            -34288,
            -99318,
            -43013,
            -50967,
            -42601,
            -45851,
            -49101,
            -43268,
            -46286
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                -39859,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3859,
                -2711,
                -2664,
                -2980,
                -2946,
                -3726,
                -2952,
                -3156,
                -3519,
                -3055,
                -2667,
                -3449
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -343,
                -328,
                -294,
                -381,
                -352,
                -333,
                -349,
                -383,
                -302,
                -354,
                -411,
                -353
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1317,
                -1103,
                -917,
                -980,
                -940,
                -1052,
                -1249,
                -1033,
                -1182,
                -1116,
                -1041,
                -925
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -9020,
                -8917,
                -9973,
                -10056,
                -11490,
                -8942,
                -11091,
                -12409,
                -11803,
                -10534,
                -8319,
                -10082
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -33233,
                -23340,
                -19590,
                -22873,
                -26590,
                -19153,
                -27978,
                -24049,
                -18902,
                -25864,
                -21289,
                -20757
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -355,
                -447,
                -354,
                -449,
                -356,
                -387,
                -498,
                -389,
                -338,
                -408,
                -354,
                -388
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1932,
                -2385,
                -2487,
                -2355,
                -2587,
                -2532,
                -1891,
                -2261,
                -2441,
                -2032,
                -2541,
                -1890
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -420,
                -384,
                -365,
                -505,
                -465,
                -512,
                -459,
                -462,
                -360,
                -399,
                -446,
                -418
              ]
            }
          }
        },
        "Supply Chain": {
          "monthly_total": [
            -62119,
            -51639,
            -65436,
            -47106,
            -105755,
            -62787,
            -58962,
            -64115,
            -56898,
            -55956,
            -45538,
            -52307
          ],
          "by_gl": {
            "15040": {
              "name": "Furniture",
              "monthly": [
                -396,
                -352,
                -443,
                -309,
                -371,
                -390,
                -378,
                -342,
                -301,
                -352,
                -394,
                -442
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3910,
                -2690,
                -3521,
                -3919,
                -2908,
                -2852,
                -3150,
                -3834,
                -2826,
                -3352,
                -2742,
                -2928
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -257,
                -215,
                -249,
                -208,
                -258,
                -236,
                -195,
                -238,
                -207,
                -196,
                -230,
                -187
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -35134,
                -20823,
                -23233,
                -18852,
                -31467,
                -19627,
                -25202,
                -24761,
                -17865,
                -24258,
                -19524,
                -22028
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -805,
                -393,
                -381,
                -385,
                -409,
                -382,
                -433,
                -405,
                -322,
                -438,
                -416,
                -381
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2451,
                -2189,
                -2326,
                -2572,
                -2410,
                -2031,
                -1832,
                -2255,
                -2462,
                -2694,
                -2165,
                -2509
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -54553,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -21748,
                -26559,
                -27284,
                -30074,
                -29974,
                -24347,
                -30983,
                -24797,
                -29098,
                -23572,
                -21441,
                -23069
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1340,
                -1187,
                -1354,
                -1682,
                -1710,
                -1204,
                -1733,
                -1511,
                -1696,
                -1609,
                -1683,
                -1596
              ]
            }
          }
        },
        "Facilities": {
          "monthly_total": [
            -343205,
            -280645,
            -302516,
            -234319,
            -341418,
            -226998,
            -244858,
            -269741,
            -302735,
            -312009,
            -277883,
            -231785
          ],
          "by_gl": {
            "15010": {
              "name": "Leasehold Improvements",
              "monthly": [
                -40939,
                -27046,
                -37139,
                -33953,
                -39603,
                -32351,
                -36580,
                -34993,
                -27967,
                -32034,
                -28853,
                -35914
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -3519,
                -4428,
                -4555,
                -4264,
                -3717,
                -3584,
                -4355,
                -4141,
                -3306,
                -3677,
                -4509,
                -4739
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -11668,
                -12671,
                -11491,
                -9950,
                -13715,
                -10040,
                -13187,
                -12140,
                -11405,
                -14097,
                -13832,
                -13270
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -8614,
                -7813,
                -6589,
                -6542,
                -7396,
                -8629,
                -6936,
                -9333,
                -8058,
                -7073,
                -7987,
                -6700
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1219,
                -1260,
                -1275,
                -1186,
                -1184,
                -1034,
                -1059,
                -1437,
                -1243,
                -981,
                -1178,
                -1211
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -82699,
                -56758,
                -64604,
                -64251,
                -82598,
                -50947,
                -84131,
                -48303,
                -67259,
                -69942,
                -50413,
                -53272
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1116,
                -1372,
                -1043,
                -1063,
                -1376,
                -1133,
                -977,
                -1078,
                -1180,
                -996,
                -1186,
                -1212
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -6949,
                -5820,
                -7177,
                -6703,
                -6278,
                -7417,
                -7091,
                -5115,
                -6400,
                -6441,
                -7261,
                -5543
              ]
            },
            "65010": {
              "name": "Rent",
              "monthly": [
                -115415,
                -93603,
                -145841,
                -111204,
                -118558,
                -122342,
                -105957,
                -115032,
                -97918,
                -125953,
                -141976,
                -107651
              ]
            },
            "65040": {
              "name": "Office Cleaning & Maintenance",
              "monthly": [
                -23434,
                -15357,
                -18895,
                -21667,
                -17702,
                -22119,
                -22136,
                -22888,
                -21738,
                -22583,
                -22252,
                -22865
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -469,
                -452,
                -421,
                -422,
                -440,
                -451,
                -395,
                -378,
                -492,
                -344,
                -404,
                -501
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -800,
                -956,
                -1034,
                -1000,
                -975,
                -995,
                -1023,
                -945,
                -738,
                -749,
                -818,
                -732
              ]
            }
          }
        },
        "IT": {
          "monthly_total": [
            -41238,
            -37113,
            -35006,
            -50115,
            -52516,
            -34317,
            -51039,
            -37225,
            -40909,
            -53650,
            -46209,
            -39222
          ],
          "by_gl": {
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                -10506,
                -10877,
                -12568,
                -9462,
                -9628,
                -12539,
                -10411,
                -9173,
                -10789,
                -11518,
                -8581,
                -11247
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -16121,
                -9208,
                -9904,
                -10731,
                -15078,
                -9546,
                -12256,
                -12524,
                -10910,
                -14239,
                -9497,
                -10114
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -256,
                -246,
                -183,
                -176,
                -206,
                -235,
                -202,
                -263,
                -219,
                -225,
                -239,
                -191
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1255,
                -961,
                -915,
                -1306,
                -995,
                -1132,
                -1089,
                -1208,
                -1118,
                -1325,
                -1097,
                -1242
              ]
            },
            "65030": {
              "name": "Internet",
              "monthly": [
                -846,
                -788,
                -827,
                -1015,
                -1003,
                -741,
                -824,
                -1013,
                -738,
                -867,
                -1039,
                -943
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -14005,
                -14680,
                -17962,
                -20495,
                -34345,
                -17841,
                -18026,
                -18997,
                -14039,
                -14148,
                -13712,
                -13717
              ]
            },
            "66030": {
              "name": "IT Supplies & Small Equipments",
              "monthly": [
                -2216,
                -1512,
                -1832,
                -1782,
                -1852,
                -1869,
                -1544,
                -2153,
                -1879,
                -1540,
                -1779,
                -1733
              ]
            }
          }
        },
        "Design Control & Testing": {
          "monthly_total": [
            -163503,
            -120285,
            -131749,
            -146735,
            -154907,
            -163815,
            -159398,
            -154284,
            -132777,
            -147156,
            -166693,
            -142038
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3302,
                -3144,
                -4387,
                -3222,
                -3546,
                -3460,
                -3377,
                -3460,
                -3206,
                -3913,
                -4579,
                -3466
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -2635,
                -2523,
                -2689,
                -2705,
                -2304,
                -2536,
                -2585,
                -2208,
                -2706,
                -2721,
                -2359,
                -2741
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -64743,
                -76204,
                -67029,
                -84156,
                -62591,
                -74436,
                -70661,
                -83054,
                -64783,
                -79875,
                -59997,
                -70352
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -82518,
                -49109,
                -67247,
                -48313,
                -82027,
                -51483,
                -82886,
                -57587,
                -60768,
                -64677,
                -51888,
                -49579
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1091,
                -933,
                -930,
                -1251,
                -923,
                -1235,
                -1215,
                -1177,
                -1180,
                -956,
                -1079,
                -1249
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -6105,
                -6326,
                -5271,
                -6294,
                -6745,
                -6391,
                -5222,
                -5556,
                -4815,
                -5582,
                -5453,
                -6421
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Quality": {
          "monthly_total": [
            -65146,
            -135273,
            -45357,
            -40259,
            -55893,
            -36827,
            -52974,
            -46000,
            -51716,
            -55564,
            -50682,
            -52695
          ],
          "by_gl": {
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -2986,
                -3235,
                -3316,
                -3901,
                -3300,
                -3837,
                -3504,
                -3136,
                -2813,
                -4037,
                -3775,
                -4114
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -63067,
                -35024,
                -38129,
                -37050,
                -48846,
                -35107,
                -45956,
                -31067,
                -29176,
                -49752,
                -38985,
                -33700
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -680,
                -671,
                -819,
                -826,
                -582,
                -632,
                -661,
                -671,
                -717,
                -676,
                -634,
                -732
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -4307,
                -2962,
                -3115,
                -3100,
                -3003,
                -3518,
                -4313,
                -3014,
                -3973,
                -3582,
                -4237,
                -3376
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -2144,
                -2065,
                -2526,
                -2065,
                -2432,
                -2094,
                -1822,
                -2412,
                -1899,
                -2344,
                -1906,
                -2501
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                -65254,
                0,
                0,
                -806,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Clinical & Regulatory": {
          "monthly_total": [
            -1478640,
            -795304,
            -1030836,
            -993259,
            -904659,
            -934370,
            -1122554,
            -809274,
            -907296,
            -860041,
            -825655,
            -974768
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "52100": {
              "name": "Animal Testing",
              "monthly": [
                -14497,
                -15306,
                -15656,
                -16128,
                -13543,
                -13053,
                -17051,
                -15498,
                -16125,
                -16076,
                -14775,
                -14865
              ]
            },
            "52200": {
              "name": "Clinical Trial Costs",
              "monthly": [
                -578834,
                -379105,
                -428076,
                -451933,
                -470848,
                -537054,
                -418284,
                -418400,
                -481043,
                -441125,
                -506059,
                -407561
              ]
            },
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -3961,
                -2552,
                -3671,
                -3055,
                -2724,
                -3604,
                -3188,
                -3846,
                -3082,
                -3576,
                -3644,
                -2709
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -681104,
                -282617,
                -253452,
                -201934,
                -293395,
                -212622,
                -256841,
                -237152,
                -257616,
                -287090,
                -274950,
                -296816
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -4722,
                -3981,
                -4719,
                -4583,
                -5049,
                -3688,
                -4260,
                -4689,
                -3572,
                -3628,
                -4198,
                -4895
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -24899,
                -24657,
                -25375,
                -19666,
                -25243,
                -22100,
                -26572,
                -18830,
                -26510,
                -21543,
                -21189,
                -19153
              ]
            },
            "61055": {
              "name": "Payroll Taxes (US)",
              "monthly": [
                -2728,
                -3091,
                -3767,
                -3510,
                -2674,
                -3790,
                -3025,
                -3547,
                -2675,
                -3506,
                -3595,
                -3740
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -46438,
                -43317,
                -45821,
                -42907,
                -48015,
                -50641,
                -55363,
                -61425,
                -55135,
                -54815,
                -54694,
                -48885
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1891,
                -1422,
                -1838,
                -1491,
                -1797,
                -1362,
                -1796,
                -1778,
                -1802,
                -1745,
                -1496,
                -1846
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -16713,
                -14217,
                -21152,
                -16357,
                -15812,
                -16446,
                -14814,
                -19067,
                -20842,
                -14478,
                -19048,
                -21011
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -11832,
                -9931,
                -13097,
                -11969,
                -9520,
                -11980,
                -11832,
                -13673,
                -12682,
                -9341,
                -11702,
                -10324
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -21900,
                -28015,
                -26943,
                -20389,
                -24629,
                -29689,
                -27479,
                -28608,
                -26361,
                -30445,
                -26081,
                -28327
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -5672,
                -5690,
                -6592,
                -6270,
                -6352,
                -6171,
                -5681,
                -5716,
                -5876,
                -6630,
                -4997,
                -5115
              ]
            },
            "67040": {
              "name": "Conferences",
              "monthly": [
                -2630,
                -2519,
                -2716,
                -2234,
                -2629,
                -2218,
                -2982,
                -2721,
                -3119,
                -3151,
                -2913,
                -2790
              ]
            }
          }
        },
        "Intellectual Property": {
          "monthly_total": [
            -99987,
            -88394,
            -87818,
            -98000,
            -75742,
            -112228,
            -94617,
            -97210,
            -99627,
            -72664,
            -95599,
            -80926
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -32658,
                -15311,
                -14822,
                -16151,
                -24835,
                -16479,
                -24499,
                -15107,
                -19838,
                -19384,
                -18273,
                -14849
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -1374,
                -888,
                -1349,
                -1315,
                -1256,
                -1291,
                -1319,
                -1308,
                -958,
                -985,
                -1330,
                -1406
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -322,
                -317,
                -361,
                -301,
                -386,
                -344,
                -295,
                -303,
                -417,
                -332,
                -410,
                -369
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1883,
                -1682,
                -1983,
                -2093,
                -2143,
                -1866,
                -1541,
                -1816,
                -2149,
                -2190,
                -1846,
                -1889
              ]
            },
            "63021": {
              "name": "Patent Management & Patent Attorneys",
              "monthly": [
                -71593,
                -60281,
                -76458,
                -55510,
                -56571,
                -54355,
                -72380,
                -59708,
                -66068,
                -57323,
                -57854,
                -63683
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1059,
                -1289,
                -1375,
                -1451,
                -1306,
                -17936,
                -1429,
                -1307,
                -1448,
                -1358,
                -1412,
                -1215
              ]
            }
          }
        },
        "Finance & Legal": {
          "monthly_total": [
            -80951,
            -161918,
            -66636,
            -73033,
            -186144,
            -119689,
            -61967,
            -66894,
            -56069,
            -78194,
            -55573,
            -68836
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -68916,
                -35165,
                -39075,
                -34855,
                -43969,
                -37570,
                -36534,
                -27674,
                -32885,
                -37388,
                -34412,
                -30062
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -705,
                -642,
                -683,
                -728,
                -557,
                -738,
                -604,
                -642,
                -624,
                -743,
                -723,
                -696
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -3657,
                -3138,
                -3771,
                -3353,
                -2988,
                -3932,
                -3327,
                -4281,
                -3576,
                -3236,
                -4080,
                -3667
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "63010": {
              "name": "Corporate Insurance",
              "monthly": [
                -6478,
                -110489,
                -7747,
                -7294,
                -6130,
                -6868,
                -6625,
                -6753,
                -5869,
                -6642,
                -5229,
                -6222
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -19781,
                -21060,
                -23072,
                -20814,
                -27108,
                -18702,
                -26426,
                -23807,
                -18850,
                -18461,
                -25454,
                -26096
              ]
            },
            "63030": {
              "name": "Audit & Tax",
              "monthly": [
                0,
                0,
                0,
                0,
                -117648,
                -41591,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -37829,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "68010": {
              "name": "Bank Charges",
              "monthly": [
                -1057,
                -1037,
                -1485,
                -1080,
                -1296,
                -1240,
                -1383,
                -1043,
                -1083,
                -1143,
                -1058,
                -1418
              ]
            }
          }
        },
        "People": {
          "monthly_total": [
            -68379,
            -69328,
            -78089,
            -61347,
            -148681,
            -73396,
            -76963,
            -67639,
            -55272,
            -67697,
            -62013,
            -86803
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -27978,
                -17422,
                -19782,
                -15602,
                -22410,
                -15550,
                -19118,
                -19769,
                -14683,
                -21097,
                -19944,
                -17252
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -318,
                -345,
                -412,
                -406,
                -305,
                -391,
                -311,
                -303,
                -407,
                -361,
                -383,
                -366
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -329,
                -341,
                -394,
                -290,
                -337,
                -339,
                -334,
                -406,
                -337,
                -294,
                -352,
                -340
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2060,
                -1929,
                -1444,
                -1632,
                -1714,
                -1674,
                -1693,
                -2107,
                -1420,
                -1806,
                -1993,
                -1485
              ]
            },
            "61060": {
              "name": "Employee Benefits - Health Plan",
              "monthly": [
                -16223,
                -17357,
                -16874,
                -16144,
                -20475,
                -14145,
                -19276,
                -20372,
                -15840,
                -15333,
                -16079,
                -15977
              ]
            },
            "61070": {
              "name": "Employee Benefits - Cellphone",
              "monthly": [
                -5259,
                -4476,
                -5494,
                -5593,
                -5298,
                -4886,
                -5830,
                -5879,
                -5106,
                -5737,
                -4626,
                -5397
              ]
            },
            "61080": {
              "name": "Employee Benefits - Gym",
              "monthly": [
                -2945,
                -2730,
                -3325,
                -2969,
                -2640,
                -3171,
                -2601,
                -2768,
                -3359,
                -3695,
                -3228,
                -3023
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1825,
                -1626,
                -1333,
                -1690,
                -1425,
                -1769,
                -1484,
                -1601,
                -1831,
                -1529,
                -1347,
                -1617
              ]
            },
            "64020": {
              "name": "Recruiting Fees",
              "monthly": [
                -4391,
                -3061,
                -3272,
                -3733,
                -4488,
                -4256,
                -3608,
                -3917,
                -4291,
                -4408,
                -3185,
                -4201
              ]
            },
            "64050": {
              "name": "Team Training",
              "monthly": [
                -764,
                -593,
                -737,
                -658,
                -664,
                -716,
                -9250,
                -658,
                -664,
                -710,
                -634,
                -854
              ]
            },
            "64060": {
              "name": "Team Events & Gifts",
              "monthly": [
                -10629,
                -1678,
                -2167,
                -6988,
                -1932,
                -1693,
                -2093,
                -1748,
                -2143,
                -5413,
                -1756,
                -11889
              ]
            },
            "64070": {
              "name": "Team Meals",
              "monthly": [
                -7072,
                -6024,
                -6675,
                -5553,
                -6521,
                -5408,
                -5581,
                -7530,
                -5990,
                -6770,
                -7442,
                -6403
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -661,
                -613,
                -547,
                -634,
                -81379,
                -664,
                -630,
                -504,
                -537,
                -572,
                -536,
                -527
              ]
            },
            "66020": {
              "name": "Professional Licenses",
              "monthly": [
                -51,
                -59,
                -5097,
                -58,
                -48,
                -49,
                -49,
                -48,
                -50,
                -54,
                -53,
                -49
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -2640,
                -2425,
                -2214,
                -2248,
                -2758,
                -2810,
                -2821,
                -2188,
                -2352,
                -2436,
                -1926,
                -2189
              ]
            }
          }
        },
        "Executive": {
          "monthly_total": [
            -470769,
            -264022,
            -255205,
            -249563,
            -359813,
            -207588,
            -243780,
            -291825,
            -210029,
            -266703,
            -406044,
            -430366
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -467798,
                -199691,
                -174548,
                -201302,
                -251679,
                -216369,
                -212203,
                -224563,
                -242188,
                -239046,
                -279723,
                -316865
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -3952,
                -3852,
                -5464,
                -3985,
                -5655,
                -4588,
                -3823,
                -4313,
                -4284,
                -4175,
                -4038,
                -4846
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -23846,
                -21780,
                -20374,
                -28208,
                -25011,
                -28845,
                -25558,
                -22417,
                -28908,
                -26843,
                -28976,
                -22479
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -152,
                -138,
                -127,
                -138,
                -128,
                -161,
                -172,
                -162,
                -121,
                -162,
                -133,
                -124
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -5326,
                -6812,
                -6993,
                -7204,
                -5662,
                -6461,
                -6577,
                -5776,
                -5595,
                -5814,
                -6714,
                -7070
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -3512,
                -3249,
                -2783,
                -3259,
                -2676,
                -2854,
                -2457,
                -3075,
                -3182,
                -2444,
                -2401,
                -2446
              ]
            }
          }
        },
        "Commercial": {
          "monthly_total": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            -44841,
            -56894
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -50744,
                -35658
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -705,
                -647
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -3736,
                -4568
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                -6096,
                -6209
              ]
            }
          }
        },
        "All company": {
          "monthly_total": [
            -5229840,
            -2973270,
            -2489300,
            -3579745,
            -3057656,
            -2713056,
            -3308925,
            -2824978,
            -2644185,
            -3127138,
            -3489423,
            -3495405
          ],
          "by_gl": {}
        }
      }
    },
    "2030": {
      "depts": {
        "Engineering": {
          "monthly_total": [
            -537010,
            -91304,
            -63821,
            -100648,
            -86690,
            -64221,
            -104485,
            -74811,
            -81407,
            -100002,
            -72333,
            -115289
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -457634,
                -56826,
                -55359,
                -98678,
                -76344,
                -79878,
                -72223,
                -61099,
                -65698,
                -80286,
                -64856,
                -83858
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2007,
                -1649,
                -1937,
                -2315,
                -2133,
                -2332,
                -1592,
                -1901,
                -2324,
                -1836,
                -1806,
                -2083
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -11746,
                -10436,
                -10604,
                -8318,
                -10734,
                -10071,
                -11596,
                -10689,
                -10170,
                -8877,
                -11953,
                -11950
              ]
            }
          }
        },
        "Electrical & Software": {
          "monthly_total": [
            -323089,
            -161695,
            -159348,
            -247041,
            -189537,
            -160670,
            -272550,
            -257807,
            -294181,
            -296679,
            -274533,
            -299999
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -5069,
                -4695,
                -4602,
                -4569,
                -5894,
                -4884,
                -4351,
                -5431,
                -5701,
                -5315,
                -4159,
                -5456
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -627,
                -795,
                -718,
                -813,
                -909,
                -700,
                -939,
                -691,
                -837,
                -934,
                -620,
                -788
              ]
            },
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51011": {
              "name": "Device Component",
              "monthly": [
                -18787,
                -17208,
                -18476,
                -20103,
                -17143,
                -16844,
                -66422,
                -73389,
                -69586,
                -91572,
                -89641,
                -73805
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -4692,
                -5661,
                -5641,
                -5215,
                -6124,
                -5579,
                -5777,
                -4673,
                -6111,
                -6300,
                -5725,
                -5847
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -4626,
                -3797,
                -3552,
                -4646,
                -4494,
                -3433,
                -4478,
                -4726,
                -4308,
                -4518,
                -4626,
                -4117
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -895,
                -1005,
                -1059,
                -938,
                -802,
                -1049,
                -1064,
                -980,
                -927,
                -1098,
                -932,
                -871
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1244,
                -1021,
                -1288,
                -967,
                -1288,
                -1106,
                -1277,
                -1078,
                -886,
                -1334,
                -956,
                -938
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -1104,
                -1068,
                -1101,
                -967,
                -944,
                -962,
                -1035,
                -1058,
                -981,
                -1155,
                -958,
                -1209
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -10584,
                -11551,
                -14576,
                -14651,
                -14986,
                -13680,
                -11577,
                -12360,
                -13746,
                -11364,
                -10257,
                -11583
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -231272,
                -101954,
                -129716,
                -173979,
                -110432,
                -135778,
                -127744,
                -99071,
                -118931,
                -169229,
                -109732,
                -164789
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2033,
                -2080,
                -2067,
                -2030,
                -2939,
                -2254,
                -2458,
                -2203,
                -2462,
                -2389,
                -2666,
                -2394
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -12987,
                -15440,
                -13069,
                -12063,
                -10671,
                -14919,
                -10434,
                -13126,
                -11663,
                -14251,
                -10748,
                -11448
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -2915,
                -2677,
                -3007,
                -2601,
                -3067,
                -2404,
                -3334,
                -3043,
                -2969,
                -3313,
                -3286,
                -2636
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -593,
                -485,
                -449,
                -448,
                -481,
                -476,
                -500,
                -543,
                -551,
                -475,
                -571,
                -458
              ]
            }
          }
        },
        "Mechanical Design": {
          "monthly_total": [
            -357414,
            -165383,
            -213746,
            -252251,
            -269951,
            -199928,
            -800149,
            -204989,
            -235686,
            -223045,
            -184741,
            -236377
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -4973,
                -4369,
                -5591,
                -5152,
                -4544,
                -5693,
                -5669,
                -5499,
                -5948,
                -5177,
                -5232,
                -5918
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -813,
                -699,
                -752,
                -872,
                -781,
                -889,
                -821,
                -685,
                -776,
                -851,
                -653,
                -865
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -13573,
                -12642,
                -10665,
                -44819,
                -14140,
                -12735,
                -640193,
                -10349,
                -12680,
                -9819,
                -13717,
                -11227
              ]
            },
            "51025": {
              "name": "Fixturing & Jigs",
              "monthly": [
                -3492,
                -2730,
                -4445,
                -3794,
                -3008,
                -3605,
                -3371,
                -3934,
                -3481,
                -4256,
                -4115,
                -4420
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -5946,
                -5050,
                -5047,
                -4973,
                -5422,
                -4945,
                -5985,
                -5575,
                -5202,
                -5547,
                -4997,
                -5701
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -13070,
                -16664,
                -16747,
                -13392,
                -18253,
                -14440,
                -14665,
                -18371,
                -11970,
                -14153,
                -14162,
                -14388
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -603,
                -590,
                -818,
                -731,
                -745,
                -653,
                -606,
                -587,
                -704,
                -798,
                -680,
                -624
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -276846,
                -140088,
                -125546,
                -146864,
                -135623,
                -161836,
                -152763,
                -110960,
                -153104,
                -177670,
                -118274,
                -170983
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2688,
                -2693,
                -3386,
                -3291,
                -2273,
                -2793,
                -3265,
                -2982,
                -2558,
                -2914,
                -3277,
                -3000
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -16671,
                -17231,
                -15356,
                -11954,
                -12546,
                -15441,
                -14386,
                -13410,
                -12596,
                -14113,
                -12913,
                -14313
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -2577,
                -2482,
                -2525,
                -2041,
                -70351,
                -2650,
                -2273,
                -1860,
                -2352,
                -2756,
                -2431,
                -2018
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -427,
                -352,
                -413,
                -361,
                -356,
                -370,
                -352,
                -413,
                -500,
                -349,
                -462,
                -434
              ]
            }
          }
        },
        "Operations": {
          "monthly_total": [
            -416196,
            -383198,
            -447000,
            -319449,
            -454891,
            -451219,
            -463456,
            -365732,
            -316844,
            -450279,
            -453445,
            -360196
          ],
          "by_gl": {
            "51011": {
              "name": "Device Component",
              "monthly": [
                -328464,
                -366331,
                -352830,
                -405055,
                -453085,
                -326366,
                -320988,
                -312906,
                -418462,
                -413912,
                -421934,
                -320186
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -32849,
                -16213,
                -20992,
                -19894,
                -14862,
                -18581,
                -21638,
                -18352,
                -18217,
                -20540,
                -18085,
                -21610
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -314,
                -346,
                -405,
                -428,
                -351,
                -344,
                -331,
                -428,
                -393,
                -394,
                -401,
                -328
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2010,
                -1914,
                -1875,
                -1936,
                -2183,
                -2025,
                -1919,
                -2020,
                -2375,
                -1940,
                -2205,
                -1766
              ]
            }
          }
        },
        "Machine Shop & Metrology": {
          "monthly_total": [
            -351408,
            -279109,
            -211424,
            -287193,
            -258537,
            -185297,
            -252938,
            -228899,
            -220224,
            -267362,
            -243649,
            -204502
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -23187,
                -17210,
                -25805,
                -19748,
                -20700,
                -23730,
                -25963,
                -21982,
                -25303,
                -19835,
                -25275,
                -21194
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -3572,
                -2879,
                -3011,
                -2673,
                -3580,
                -3573,
                -3284,
                -3226,
                -3258,
                -2556,
                -3049,
                -3140
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -14036,
                -14650,
                -11003,
                -11072,
                -15561,
                -13380,
                -12217,
                -14450,
                -15039,
                -11590,
                -14249,
                -14321
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -21179,
                -22849,
                -27003,
                -20144,
                -26801,
                -26542,
                -25338,
                -28811,
                -19637,
                -26884,
                -24085,
                -28394
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -19897,
                -19040,
                -21802,
                -24386,
                -20633,
                -19229,
                -23541,
                -17586,
                -20140,
                -22765,
                -20582,
                -21002
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -5051,
                -3977,
                -5833,
                -4578,
                -5127,
                -5464,
                -5166,
                -5278,
                -5863,
                -5282,
                -5311,
                -5774
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -167785,
                -110022,
                -93838,
                -158920,
                -132237,
                -115988,
                -143072,
                -94702,
                -98270,
                -131656,
                -92330,
                -143651
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2274,
                -2044,
                -2766,
                -2213,
                -2365,
                -2538,
                -2744,
                -2051,
                -2504,
                -2658,
                -2212,
                -2604
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -12686,
                -13970,
                -13954,
                -10342,
                -14698,
                -14616,
                -10970,
                -13096,
                -10120,
                -11780,
                -14659,
                -10314
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -509,
                -23576,
                -574,
                -449,
                -617,
                -636,
                -472,
                -533,
                -474,
                -666,
                -441,
                -498
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -123,
                -105,
                -132,
                -99,
                -100,
                -113,
                -134,
                -137,
                -120,
                -138,
                -106,
                -125
              ]
            }
          }
        },
        "Cleanroom": {
          "monthly_total": [
            -55408,
            -36680,
            -42818,
            -48925,
            -88574,
            -48960,
            -45292,
            -49002,
            -35985,
            -43426,
            -43293,
            -43703
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                -48410,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3493,
                -3272,
                -3938,
                -2751,
                -3143,
                -3490,
                -3816,
                -3779,
                -2900,
                -2895,
                -2824,
                -4089
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -417,
                -323,
                -399,
                -305,
                -336,
                -376,
                -399,
                -415,
                -419,
                -359,
                -314,
                -440
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1011,
                -1102,
                -1342,
                -1167,
                -1357,
                -1340,
                -963,
                -1203,
                -1342,
                -1197,
                -1075,
                -1044
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -9882,
                -10650,
                -12321,
                -11963,
                -9081,
                -11920,
                -8835,
                -9831,
                -8954,
                -10111,
                -8741,
                -13146
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -33071,
                -20599,
                -24305,
                -27368,
                -24034,
                -24129,
                -23322,
                -18767,
                -24558,
                -29651,
                -22542,
                -22124
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -432,
                -508,
                -495,
                -551,
                -380,
                -495,
                -529,
                -429,
                -514,
                -530,
                -503,
                -503
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2271,
                -2434,
                -2138,
                -2271,
                -2622,
                -2537,
                -1993,
                -2174,
                -1975,
                -2782,
                -2386,
                -2769
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -417,
                -499,
                -429,
                -430,
                -432,
                -536,
                -563,
                -541,
                -447,
                -561,
                -480,
                -445
              ]
            }
          }
        },
        "Supply Chain": {
          "monthly_total": [
            -88821,
            -65602,
            -67090,
            -56981,
            -135850,
            -63556,
            -60631,
            -62588,
            -65201,
            -76352,
            -56612,
            -60687
          ],
          "by_gl": {
            "15040": {
              "name": "Furniture",
              "monthly": [
                -421,
                -375,
                -335,
                -445,
                -445,
                -383,
                -405,
                -414,
                -354,
                -455,
                -305,
                -360
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -3629,
                -3410,
                -3992,
                -4664,
                -3859,
                -3991,
                -3774,
                -3271,
                -3483,
                -3986,
                -3728,
                -4550
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -206,
                -229,
                -266,
                -199,
                -268,
                -259,
                -246,
                -258,
                -272,
                -200,
                -225,
                -281
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -39087,
                -25064,
                -22904,
                -24564,
                -23470,
                -20390,
                -30380,
                -24661,
                -21028,
                -32720,
                -23323,
                -31013
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -814,
                -414,
                -503,
                -595,
                -477,
                -357,
                -539,
                -437,
                -408,
                -446,
                -466,
                -546
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2803,
                -2399,
                -2306,
                -2701,
                -2106,
                -2234,
                -2211,
                -2744,
                -2944,
                -2786,
                -2556,
                -2992
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -50084,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -24219,
                -30533,
                -27937,
                -23493,
                -32316,
                -28520,
                -25505,
                -28571,
                -29058,
                -34512,
                -29937,
                -29635
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1636,
                -1698,
                -1374,
                -1637,
                -1313,
                -1511,
                -1874,
                -1684,
                -1490,
                -1351,
                -1285,
                -1581
              ]
            }
          }
        },
        "Facilities": {
          "monthly_total": [
            -342898,
            -294454,
            -327446,
            -337831,
            -295536,
            -262761,
            -292118,
            -241308,
            -320013,
            -294213,
            -291830,
            -313399
          ],
          "by_gl": {
            "15010": {
              "name": "Leasehold Improvements",
              "monthly": [
                -32150,
                -27380,
                -40592,
                -28061,
                -41025,
                -32967,
                -38963,
                -38854,
                -39269,
                -37930,
                -27481,
                -38507
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -4306,
                -3940,
                -4520,
                -4271,
                -5103,
                -5105,
                -3757,
                -4113,
                -4254,
                -3766,
                -4038,
                -4911
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -13555,
                -12426,
                -14654,
                -14838,
                -11102,
                -12798,
                -11337,
                -14127,
                -13783,
                -11422,
                -11343,
                -12727
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -8085,
                -8354,
                -8025,
                -7575,
                -8185,
                -8060,
                -9333,
                -10120,
                -8593,
                -7159,
                -7496,
                -8957
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1097,
                -1027,
                -1457,
                -1224,
                -1061,
                -1440,
                -1073,
                -1409,
                -1002,
                -1156,
                -1145,
                -1323
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -119557,
                -57339,
                -55238,
                -84589,
                -62311,
                -63879,
                -86904,
                -55738,
                -60833,
                -93072,
                -71262,
                -88279
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1210,
                -1276,
                -1462,
                -1551,
                -1228,
                -1576,
                -1309,
                -1309,
                -1513,
                -1109,
                -1477,
                -1397
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -6915,
                -6443,
                -5787,
                -8042,
                -8131,
                -7777,
                -7449,
                -7167,
                -8302,
                -7866,
                -7275,
                -6485
              ]
            },
            "65010": {
              "name": "Rent",
              "monthly": [
                -113816,
                -104358,
                -148771,
                -124113,
                -108401,
                -108479,
                -121529,
                -115164,
                -124386,
                -151122,
                -125305,
                -153911
              ]
            },
            "65040": {
              "name": "Office Cleaning & Maintenance",
              "monthly": [
                -11860,
                -11788,
                -13357,
                -12126,
                -15123,
                -14435,
                -11043,
                -15231,
                -11858,
                -10941,
                -12502,
                -10972
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -524,
                -345,
                -531,
                -426,
                -499,
                -496,
                -505,
                -385,
                -481,
                -391,
                -508,
                -433
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -760,
                -827,
                -980,
                -1036,
                -1068,
                -791,
                -1014,
                -950,
                -1024,
                -768,
                -1026,
                -796
              ]
            }
          }
        },
        "IT": {
          "monthly_total": [
            -57715,
            -45178,
            -55608,
            -56856,
            -74850,
            -43738,
            -56143,
            -52910,
            -47932,
            -51052,
            -58823,
            -51790
          ],
          "by_gl": {
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                -14525,
                -12187,
                -13192,
                -14434,
                -16162,
                -15947,
                -14773,
                -15136,
                -12719,
                -12806,
                -14366,
                -15811
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -17490,
                -11331,
                -11903,
                -16429,
                -13246,
                -10992,
                -16026,
                -13000,
                -10726,
                -16837,
                -10985,
                -16959
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -273,
                -253,
                -238,
                -228,
                -288,
                -226,
                -227,
                -250,
                -202,
                -243,
                -210,
                -252
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1480,
                -1229,
                -1117,
                -1316,
                -1504,
                -1084,
                -1022,
                -1332,
                -1021,
                -1033,
                -1257,
                -1013
              ]
            },
            "65030": {
              "name": "Internet",
              "monthly": [
                -1002,
                -719,
                -759,
                -960,
                -951,
                -799,
                -1098,
                -1025,
                -906,
                -942,
                -788,
                -937
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -21794,
                -24064,
                -18672,
                -23058,
                -43086,
                -18504,
                -16706,
                -17867,
                -21318,
                -16769,
                -16605,
                -23549
              ]
            },
            "66030": {
              "name": "IT Supplies & Small Equipments",
              "monthly": [
                -2555,
                -2276,
                -3109,
                -3045,
                -3027,
                -2228,
                -2708,
                -2967,
                -2105,
                -2981,
                -2174,
                -2455
              ]
            }
          }
        },
        "Design Control & Testing": {
          "monthly_total": [
            -222180,
            -157093,
            -148160,
            -133015,
            -139964,
            -161509,
            -176132,
            -149064,
            -167432,
            -192817,
            -122368,
            -180923
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -4165,
                -3168,
                -4137,
                -3611,
                -4420,
                -3987,
                -3698,
                -3913,
                -4093,
                -3668,
                -3630,
                -4122
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -3122,
                -2543,
                -2660,
                -2628,
                -2382,
                -2939,
                -2303,
                -2327,
                -3011,
                -2477,
                -3298,
                -2758
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -82487,
                -76352,
                -86977,
                -73215,
                -76528,
                -72442,
                -76781,
                -67971,
                -83853,
                -89750,
                -83258,
                -90870
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -116011,
                -63642,
                -64364,
                -72099,
                -53924,
                -52059,
                -79119,
                -66438,
                -69785,
                -77151,
                -64750,
                -68617
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1031,
                -1051,
                -1202,
                -1260,
                -1414,
                -1004,
                -1162,
                -1193,
                -1308,
                -1396,
                -1338,
                -1072
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -6165,
                -7485,
                -7584,
                -5563,
                -6389,
                -7682,
                -6773,
                -5988,
                -6751,
                -6871,
                -6055,
                -5851
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Quality": {
          "monthly_total": [
            -70854,
            -119923,
            -46492,
            -68951,
            -49672,
            -51884,
            -45058,
            -39698,
            -38385,
            -55086,
            -46830,
            -48418
          ],
          "by_gl": {
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -6894,
                -7275,
                -6580,
                -9076,
                -9105,
                -6342,
                -375,
                -351,
                -439,
                -328,
                -323,
                -364
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -59406,
                -43693,
                -40541,
                -49230,
                -36373,
                -31879,
                -39466,
                -32014,
                -43345,
                -51347,
                -39168,
                -55876
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -750,
                -814,
                -744,
                -729,
                -678,
                -668,
                -799,
                -719,
                -671,
                -802,
                -684,
                -703
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -3935,
                -4207,
                -3696,
                -3780,
                -4625,
                -4509,
                -4519,
                -4034,
                -4484,
                -3588,
                -4695,
                -3831
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -2719,
                -1871,
                -2122,
                -1998,
                -2247,
                -2369,
                -2816,
                -2152,
                -2181,
                -2338,
                -2450,
                -2701
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                -87108,
                0,
                0,
                -657,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Clinical & Regulatory": {
          "monthly_total": [
            -1116518,
            -489868,
            -520795,
            -508397,
            -423924,
            -397060,
            -618418,
            -507825,
            -691047,
            -540205,
            -515900,
            -534202
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "52100": {
              "name": "Animal Testing",
              "monthly": [
                -14194,
                -11508,
                -16179,
                -15068,
                -15319,
                -16268,
                -11846,
                -13866,
                -14255,
                -12991,
                -13416,
                -13121
              ]
            },
            "52200": {
              "name": "Clinical Trial Costs",
              "monthly": [
                -16260,
                -12394,
                -14515,
                -15732,
                -16383,
                -16640,
                -17804,
                -18510,
                -16434,
                -15701,
                -15932,
                -14591
              ]
            },
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -3170,
                -3386,
                -3848,
                -2897,
                -3773,
                -2811,
                -3564,
                -3317,
                -229270,
                -3081,
                -2859,
                -3887
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -865536,
                -254224,
                -318901,
                -268417,
                -299601,
                -269008,
                -293263,
                -320700,
                -329532,
                -360163,
                -318443,
                -279321
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -4768,
                -5170,
                -5461,
                -3845,
                -4677,
                -4363,
                -5157,
                -4592,
                -4916,
                -5124,
                -4433,
                -4284
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -19977,
                -29784,
                -23459,
                -28280,
                -24566,
                -25124,
                -24045,
                -29383,
                -29088,
                -28212,
                -25937,
                -26794
              ]
            },
            "61055": {
              "name": "Payroll Taxes (US)",
              "monthly": [
                -3678,
                -3993,
                -3737,
                -4927,
                -3703,
                -4581,
                -3489,
                -5033,
                -4304,
                -4585,
                -4508,
                -4412
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -64875,
                -44216,
                -58642,
                -55748,
                -54861,
                -45844,
                -65533,
                -53046,
                -45649,
                -66560,
                -57469,
                -57374
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1642,
                -1553,
                -1802,
                -1785,
                -1509,
                -1442,
                -1662,
                -1987,
                -1707,
                -1651,
                -1494,
                -1596
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -19346,
                -17661,
                -17470,
                -17223,
                -15593,
                -13986,
                -17061,
                -20309,
                -14222,
                -16137,
                -16880,
                -16110
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -11912,
                -10571,
                -12599,
                -8986,
                -9730,
                -12781,
                -13508,
                -12955,
                -9373,
                -10533,
                -10853,
                -10290
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -25841,
                -26248,
                -24995,
                -20732,
                -27602,
                -29472,
                -21209,
                -26453,
                -21070,
                -23423,
                -28698,
                -22529
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -4558,
                -4744,
                -5923,
                -5762,
                -4749,
                -5717,
                -5759,
                -6527,
                -4864,
                -6185,
                -5749,
                -5334
              ]
            },
            "67040": {
              "name": "Conferences",
              "monthly": [
                -2309,
                -2512,
                -3079,
                -3207,
                -2994,
                -2410,
                -2413,
                -2689,
                -2852,
                -2976,
                -2541,
                -2988
              ]
            }
          }
        },
        "Intellectual Property": {
          "monthly_total": [
            -119110,
            -95735,
            -115025,
            -96320,
            -85496,
            -113063,
            -119176,
            -114151,
            -77336,
            -116752,
            -71209,
            -112270
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -31963,
                -18774,
                -15205,
                -19207,
                -15313,
                -16902,
                -18788,
                -16722,
                -19750,
                -19373,
                -19753,
                -21892
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -1204,
                -1266,
                -1288,
                -1267,
                -966,
                -999,
                -1377,
                -1094,
                -1276,
                -1229,
                -1042,
                -1326
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -378,
                -385,
                -328,
                -385,
                -423,
                -377,
                -426,
                -346,
                -415,
                -320,
                -425,
                -315
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2373,
                -2331,
                -2089,
                -1782,
                -2217,
                -1744,
                -2414,
                -2146,
                -1956,
                -1780,
                -1904,
                -1811
              ]
            },
            "63021": {
              "name": "Patent Management & Patent Attorneys",
              "monthly": [
                -89010,
                -62380,
                -66302,
                -70454,
                -66868,
                -64659,
                -84457,
                -60472,
                -77283,
                -83096,
                -63670,
                -68300
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1470,
                -1052,
                -1519,
                -1280,
                -1406,
                -15214,
                -1449,
                -1102,
                -1415,
                -1218,
                -1260,
                -1284
              ]
            }
          }
        },
        "Finance & Legal": {
          "monthly_total": [
            -97291,
            -193447,
            -85919,
            -71256,
            -186599,
            -136913,
            -75312,
            -82129,
            -84847,
            -76793,
            -79777,
            -69871
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -66751,
                -37735,
                -42591,
                -39810,
                -31023,
                -42993,
                -50483,
                -39464,
                -32975,
                -49257,
                -39599,
                -45177
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -752,
                -642,
                -807,
                -803,
                -641,
                -748,
                -683,
                -721,
                -798,
                -724,
                -699,
                -645
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -4304,
                -3358,
                -3157,
                -3886,
                -4276,
                -3270,
                -4629,
                -3581,
                -3910,
                -4461,
                -4089,
                -3850
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "63010": {
              "name": "Corporate Insurance",
              "monthly": [
                -7766,
                -119313,
                -6123,
                -5273,
                -6381,
                -7455,
                -5984,
                -5524,
                -7479,
                -7177,
                -6691,
                -6151
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -19867,
                -23683,
                -19822,
                -23092,
                -28251,
                -21004,
                -21197,
                -25269,
                -21392,
                -28406,
                -27029,
                -19506
              ]
            },
            "63030": {
              "name": "Audit & Tax",
              "monthly": [
                0,
                0,
                0,
                0,
                -103945,
                -48518,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -52004,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "68010": {
              "name": "Bank Charges",
              "monthly": [
                -1382,
                -1516,
                -1256,
                -1182,
                -1500,
                -1530,
                -1172,
                -1273,
                -1522,
                -1177,
                -1408,
                -1212
              ]
            }
          }
        },
        "People": {
          "monthly_total": [
            -91295,
            -68588,
            -88932,
            -83528,
            -156720,
            -78931,
            -84952,
            -75500,
            -79652,
            -65575,
            -67920,
            -95928
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -34935,
                -16732,
                -17368,
                -20442,
                -14914,
                -20449,
                -25390,
                -15737,
                -20273,
                -19882,
                -19210,
                -19015
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -282,
                -369,
                -383,
                -302,
                -407,
                -274,
                -408,
                -385,
                -346,
                -313,
                -356,
                -406
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -419,
                -425,
                -385,
                -403,
                -436,
                -350,
                -358,
                -313,
                -340,
                -418,
                -420,
                -430
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2119,
                -2304,
                -1882,
                -1965,
                -2088,
                -1814,
                -1820,
                -1810,
                -1658,
                -2339,
                -1768,
                -1752
              ]
            },
            "61060": {
              "name": "Employee Benefits - Health Plan",
              "monthly": [
                -25466,
                -21412,
                -19324,
                -20448,
                -23705,
                -22968,
                -19116,
                -19952,
                -25687,
                -24266,
                -19568,
                -23339
              ]
            },
            "61070": {
              "name": "Employee Benefits - Cellphone",
              "monthly": [
                -5162,
                -5160,
                -5253,
                -5633,
                -4790,
                -5435,
                -6463,
                -4731,
                -5770,
                -6728,
                -6049,
                -6484
              ]
            },
            "61080": {
              "name": "Employee Benefits - Gym",
              "monthly": [
                -4514,
                -3653,
                -3588,
                -4187,
                -3890,
                -3727,
                -3796,
                -4588,
                -3762,
                -4250,
                -3114,
                -3133
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1663,
                -1583,
                -1554,
                -1611,
                -1759,
                -1810,
                -1909,
                -1780,
                -1531,
                -2017,
                -1570,
                -1859
              ]
            },
            "64020": {
              "name": "Recruiting Fees",
              "monthly": [
                -4565,
                -3413,
                -4463,
                -4122,
                -4371,
                -3426,
                -4028,
                -3445,
                -3398,
                -4262,
                -3792,
                -3591
              ]
            },
            "64050": {
              "name": "Team Training",
              "monthly": [
                -771,
                -816,
                -679,
                -752,
                -881,
                -767,
                -7345,
                -666,
                -644,
                -741,
                -656,
                -803
              ]
            },
            "64060": {
              "name": "Team Events & Gifts",
              "monthly": [
                -13149,
                -1956,
                -2489,
                -10332,
                -2593,
                -2596,
                -2220,
                -2203,
                -2481,
                -5865,
                -2623,
                -18442
              ]
            },
            "64070": {
              "name": "Team Meals",
              "monthly": [
                -7524,
                -4793,
                -6318,
                -6469,
                -5191,
                -5289,
                -6159,
                -6437,
                -5487,
                -7213,
                -6801,
                -6612
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -772,
                -571,
                -550,
                -688,
                -108630,
                -701,
                -626,
                -540,
                -708,
                -704,
                -678,
                -570
              ]
            },
            "66020": {
              "name": "Professional Licenses",
              "monthly": [
                -43,
                -60,
                -7070,
                -58,
                -43,
                -49,
                -43,
                -45,
                -49,
                -55,
                -57,
                -63
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -2816,
                -3185,
                -3494,
                -2446,
                -2898,
                -3564,
                -2607,
                -3148,
                -2791,
                -2902,
                -3129,
                -2713
              ]
            }
          }
        },
        "Executive": {
          "monthly_total": [
            -1083566,
            -583581,
            -661015,
            -803761,
            -725560,
            -742256,
            -916145,
            -736459,
            -740264,
            -800815,
            -621050,
            -916421
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -793301,
                -408028,
                -374689,
                -407992,
                -384988,
                -388934,
                -457799,
                -482748,
                -371795,
                -621981,
                -390838,
                -513939
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -8405,
                -9124,
                -8407,
                -8073,
                -9423,
                -8518,
                -10057,
                -9642,
                -8270,
                -7211,
                -9318,
                -8191
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -41247,
                -50703,
                -47121,
                -36922,
                -50243,
                -37735,
                -52734,
                -50803,
                -36622,
                -40049,
                -43851,
                -51641
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -177,
                -119,
                -144,
                -125,
                -154,
                -138,
                -130,
                -188,
                -167,
                -177,
                -144,
                -147
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -7151,
                -6505,
                -6912,
                -6011,
                -6872,
                -7195,
                -12575,
                -8544,
                -11051,
                -10086,
                -11247,
                -9564
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -3498,
                -3321,
                -2608,
                -2895,
                -2664,
                -3350,
                -2874,
                -3393,
                -2885,
                -3204,
                -3618,
                -2833
              ]
            }
          }
        },
        "Commercial": {
          "monthly_total": [
            -105534,
            -98484,
            -88206,
            -107088,
            -135246,
            -132958,
            -162649,
            -98937,
            -127984,
            -136533,
            -103572,
            -131305
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -87628,
                -73013,
                -64392,
                -103246,
                -86070,
                -93572,
                -91125,
                -97768,
                -82180,
                -107921,
                -82206,
                -115815
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1578,
                -1443,
                -1213,
                -1796,
                -1333,
                -1602,
                -1739,
                -1871,
                -1780,
                -1807,
                -1560,
                -2041
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -7730,
                -6004,
                -5890,
                -9249,
                -9677,
                -9954,
                -11737,
                -9633,
                -7676,
                -9963,
                -10009,
                -10609
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -15426,
                -18057,
                -14205,
                -18427,
                -19328,
                -13797,
                -17578,
                -17187,
                -16797,
                -18424,
                -19263,
                -15308
              ]
            }
          }
        },
        "All company": {
          "monthly_total": [
            -4497808,
            -3458784,
            -2955032,
            -3451847,
            -2874965,
            -3302676,
            -3612138,
            -2905996,
            -3623528,
            -3536502,
            -3304182,
            -3967730
          ],
          "by_gl": {}
        }
      }
    },
    "2031": {
      "depts": {
        "Engineering": {
          "monthly_total": [
            -451143,
            -95241,
            -85298,
            -87605,
            -77282,
            -89867,
            -95803,
            -106555,
            -90314,
            -72091,
            -96794,
            -107140
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -444113,
                -66460,
                -69027,
                -107836,
                -61683,
                -64183,
                -109749,
                -65514,
                -91595,
                -89762,
                -79420,
                -86871
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2116,
                -2377,
                -2126,
                -2559,
                -2051,
                -2333,
                -2166,
                -2090,
                -2536,
                -2454,
                -2576,
                -2214
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -10604,
                -9046,
                -9601,
                -10307,
                -12249,
                -9877,
                -11199,
                -13454,
                -9749,
                -10264,
                -12383,
                -9707
              ]
            }
          }
        },
        "Electrical & Software": {
          "monthly_total": [
            -284941,
            -150272,
            -173380,
            -253241,
            -220361,
            -184783,
            -245856,
            -202468,
            -237024,
            -152434,
            -174337,
            -233280
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -6642,
                -4891,
                -5927,
                -5515,
                -5895,
                -5449,
                -5923,
                -4844,
                -5767,
                -5350,
                -6533,
                -5877
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -912,
                -817,
                -715,
                -649,
                -805,
                -914,
                -930,
                -806,
                -736,
                -712,
                -951,
                -976
              ]
            },
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51011": {
              "name": "Device Component",
              "monthly": [
                -17671,
                -162,
                -145,
                -192,
                -188,
                -142,
                -152,
                -166,
                -192,
                -184,
                -177,
                -194
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -5072,
                -6816,
                -4628,
                -5294,
                -6851,
                -6304,
                -5647,
                -6613,
                -5787,
                -5067,
                -6711,
                -5713
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -5209,
                -3352,
                -5010,
                -3747,
                -4684,
                -4138,
                -3962,
                -5155,
                -3828,
                -3689,
                -3694,
                -4211
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -991,
                -1119,
                -1053,
                -1167,
                -1004,
                -814,
                -909,
                -904,
                -1089,
                -884,
                -993,
                -836
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1147,
                -1176,
                -1124,
                -1363,
                -1161,
                -1108,
                -1026,
                -1112,
                -934,
                -1036,
                -1142,
                -1022
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                -960,
                -1024,
                -1284,
                -1019,
                -1134,
                -1222,
                -1181,
                -1179,
                -993,
                -1007,
                -943,
                -1371
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -14529,
                -13951,
                -10321,
                -11560,
                -14079,
                -12759,
                -14254,
                -14390,
                -10930,
                -14677,
                -13724,
                -13906
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -197746,
                -133628,
                -117900,
                -182126,
                -154103,
                -117948,
                -150924,
                -155533,
                -154517,
                -129639,
                -108493,
                -151528
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2758,
                -2606,
                -2311,
                -2856,
                -2793,
                -2940,
                -2937,
                -2397,
                -2309,
                -3120,
                -2647,
                -2962
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -12752,
                -11859,
                -14965,
                -15940,
                -12774,
                -11565,
                -12849,
                -13855,
                -11658,
                -15848,
                -15949,
                -12597
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -4023,
                -2908,
                -3579,
                -2804,
                -3152,
                -3846,
                -3123,
                -2958,
                -3569,
                -4097,
                -2861,
                -4195
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -551,
                -434,
                -494,
                -487,
                -514,
                -522,
                -652,
                -623,
                -638,
                -473,
                -510,
                -596
              ]
            }
          }
        },
        "Mechanical Design": {
          "monthly_total": [
            -246623,
            -212242,
            -247393,
            -244789,
            -233663,
            -226816,
            -672864,
            -177288,
            -235858,
            -189486,
            -171982,
            -203346
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -6107,
                -4163,
                -5339,
                -4154,
                -5810,
                -5500,
                -4449,
                -5475,
                -5691,
                -5959,
                -4306,
                -6067
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -833,
                -690,
                -858,
                -851,
                -860,
                -652,
                -676,
                -719,
                -818,
                -708,
                -724,
                -971
              ]
            },
            "51020": {
              "name": "Engineering Consulting Fees",
              "monthly": [
                -6761,
                -6804,
                -5866,
                -38589,
                -6561,
                -6756,
                -501390,
                -6006,
                -7137,
                -8295,
                -8055,
                -8260
              ]
            },
            "51025": {
              "name": "Fixturing & Jigs",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -6310,
                -4997,
                -5803,
                -4428,
                -4467,
                -4412,
                -5443,
                -5177,
                -4576,
                -5882,
                -4870,
                -5085
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -13390,
                -17574,
                -14867,
                -16386,
                -16541,
                -13061,
                -14971,
                -16557,
                -12672,
                -17218,
                -13221,
                -19049
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -802,
                -565,
                -772,
                -854,
                -743,
                -879,
                -633,
                -629,
                -645,
                -827,
                -614,
                -667
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -269659,
                -156230,
                -145217,
                -221737,
                -132583,
                -161030,
                -211421,
                -140200,
                -154956,
                -129961,
                -136391,
                -203841
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2516,
                -2665,
                -2664,
                -3209,
                -3554,
                -3242,
                -2588,
                -2897,
                -2909,
                -2971,
                -2591,
                -3653
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -16243,
                -13221,
                -14401,
                -13445,
                -15418,
                -19405,
                -14227,
                -15249,
                -17032,
                -15370,
                -14604,
                -13102
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -2152,
                -2608,
                -2564,
                -2809,
                -78125,
                -2823,
                -2284,
                -2301,
                -2519,
                -2781,
                -2028,
                -2071
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -432,
                -364,
                -521,
                -465,
                -473,
                -481,
                -406,
                -362,
                -461,
                -484,
                -462,
                -384
              ]
            }
          }
        },
        "Operations": {
          "monthly_total": [
            -119106,
            -21367,
            -27260,
            -26374,
            -22509,
            -24172,
            -29717,
            -25169,
            -27912,
            -19992,
            -24855,
            -30442
          ],
          "by_gl": {
            "51011": {
              "name": "Device Component",
              "monthly": [
                -110320,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -24725,
                -20458,
                -17369,
                -28459,
                -19553,
                -17803,
                -27351,
                -20708,
                -25252,
                -19098,
                -18934,
                -28737
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -394,
                -424,
                -375,
                -388,
                -478,
                -483,
                -465,
                -393,
                -383,
                -439,
                -501,
                -366
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1855,
                -1976,
                -2543,
                -2208,
                -2331,
                -2193,
                -2384,
                -2378,
                -2449,
                -2062,
                -2622,
                -2172
              ]
            }
          }
        },
        "Machine Shop & Metrology": {
          "monthly_total": [
            -297910,
            -232944,
            -209812,
            -204268,
            -248167,
            -252942,
            -275288,
            -214747,
            -216659,
            -246652,
            -221190,
            -219412
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                -24628,
                -19677,
                -23939,
                -26187,
                -18927,
                -19010,
                -20081,
                -22840,
                -20788,
                -21277,
                -26677,
                -20797
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -3010,
                -3127,
                -2728,
                -2827,
                -3373,
                -3129,
                -3048,
                -2714,
                -2863,
                -2697,
                -2975,
                -2881
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -11085,
                -9813,
                -2374,
                -2470,
                -2161,
                -2599,
                -1906,
                -2526,
                -2306,
                -2524,
                -2200,
                -1956
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -24359,
                -23226,
                -19241,
                -19946,
                -18222,
                -16229,
                -18908,
                -20451,
                -18022,
                -18619,
                -15420,
                -9272
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -23338,
                -23625,
                -20650,
                -22821,
                -25142,
                -26520,
                -24049,
                -25346,
                -27868,
                -22553,
                -23675,
                -20977
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -4338,
                -3626,
                -86,
                -85,
                -82,
                -84,
                -72,
                -77,
                -78,
                -82,
                -66,
                -62
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -213781,
                -137403,
                -143480,
                -127833,
                -133773,
                -138001,
                -187665,
                -147604,
                -165520,
                -117065,
                -133386,
                -146455
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -2187,
                -2233,
                -2920,
                -2484,
                -2866,
                -2673,
                -3073,
                -2937,
                -2505,
                -2853,
                -2543,
                -2819
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -11838,
                -14495,
                -13919,
                -15726,
                -11976,
                -12973,
                -14869,
                -12130,
                -12058,
                -15983,
                -15436,
                -11509
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -563,
                -22943,
                -630,
                -509,
                -533,
                -500,
                -522,
                -675,
                -541,
                -717,
                -676,
                -484
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -113,
                -90,
                -129,
                -125,
                -134,
                -103,
                -134,
                -127,
                -143,
                -115,
                -130,
                -131
              ]
            }
          }
        },
        "Cleanroom": {
          "monthly_total": [
            -46712,
            -34581,
            -27266,
            -42432,
            -35196,
            -30049,
            -31841,
            -32905,
            -40193,
            -35375,
            -26043,
            -31815
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -94,
                -71,
                -95,
                -77,
                -76,
                -73,
                -89,
                -75,
                -87,
                -82,
                -88,
                -83
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -337,
                -405,
                -369,
                -326,
                -378,
                -356,
                -367,
                -357,
                -359,
                -446,
                -339,
                -321
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1066,
                -1304,
                -1243,
                -1179,
                -1189,
                -1076,
                -1348,
                -1194,
                -1322,
                -1078,
                -1177,
                -1375
              ]
            },
            "51055": {
              "name": "Subcontractor - Manufacturing",
              "monthly": [
                -863,
                -623,
                -760,
                -707,
                -871,
                -674,
                -822,
                -943,
                -645,
                -932,
                -814,
                -789
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -34528,
                -26874,
                -22812,
                -33888,
                -25452,
                -27322,
                -31390,
                -23010,
                -34773,
                -20444,
                -23522,
                -27352
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -449,
                -471,
                -430,
                -474,
                -527,
                -422,
                -534,
                -503,
                -552,
                -431,
                -452,
                -602
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2202,
                -2722,
                -2127,
                -2724,
                -2545,
                -2574,
                -2419,
                -2266,
                -2154,
                -2357,
                -2892,
                -2804
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -558,
                -506,
                -534,
                -522,
                -492,
                -396,
                -429,
                -452,
                -567,
                -569,
                -433,
                -540
              ]
            }
          }
        },
        "Supply Chain": {
          "monthly_total": [
            -68658,
            -69023,
            -52204,
            -77992,
            -130392,
            -56762,
            -66200,
            -52763,
            -64476,
            -61806,
            -65316,
            -74094
          ],
          "by_gl": {
            "15040": {
              "name": "Furniture",
              "monthly": [
                -334,
                -410,
                -385,
                -371,
                -390,
                -382,
                -335,
                -461,
                -378,
                -367,
                -449,
                -474
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -4407,
                -4662,
                -3897,
                -3790,
                -5328,
                -4289,
                -5076,
                -5329,
                -3984,
                -4169,
                -4229,
                -5565
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -210,
                -212,
                -259,
                -230,
                -276,
                -264,
                -209,
                -266,
                -192,
                -255,
                -220,
                -276
              ]
            },
            "51060": {
              "name": "Small Machines",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -38461,
                -25809,
                -24880,
                -30295,
                -26723,
                -22246,
                -29459,
                -23971,
                -29527,
                -27221,
                -26131,
                -36014
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -792,
                -383,
                -410,
                -530,
                -544,
                -528,
                -512,
                -453,
                -688,
                -530,
                -459,
                -601
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2584,
                -3038,
                -2216,
                -2488,
                -2815,
                -3008,
                -2279,
                -3191,
                -3001,
                -2632,
                -2255,
                -3258
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -63483,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                -20649,
                -19963,
                -20238,
                -27188,
                -29025,
                -21287,
                -25469,
                -27254,
                -22659,
                -20192,
                -20985,
                -29250
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1940,
                -1575,
                -1607,
                -1881,
                -1359,
                -1714,
                -1966,
                -1601,
                -1823,
                -1700,
                -1542,
                -1524
              ]
            }
          }
        },
        "Facilities": {
          "monthly_total": [
            -290138,
            -223206,
            -288990,
            -284584,
            -236163,
            -336726,
            -345859,
            -320830,
            -348080,
            -261481,
            -264414,
            -291166
          ],
          "by_gl": {
            "15010": {
              "name": "Leasehold Improvements",
              "monthly": [
                -29639,
                -31902,
                -37611,
                -29735,
                -34643,
                -28908,
                -39158,
                -41248,
                -33047,
                -41256,
                -31340,
                -38454
              ]
            },
            "15040": {
              "name": "Furniture",
              "monthly": [
                -5494,
                -4750,
                -4868,
                -5152,
                -4433,
                -4858,
                -3838,
                -4759,
                -4286,
                -3886,
                -4574,
                -4571
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -13987,
                -12895,
                -15204,
                -13110,
                -12749,
                -11823,
                -11616,
                -14920,
                -15548,
                -13118,
                -12456,
                -11177
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                -7805,
                -8252,
                -7469,
                -7767,
                -8534,
                -7536,
                -7274,
                -7460,
                -9030,
                -9127,
                -9895,
                -7791
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -1096,
                -1175,
                -1190,
                -1160,
                -1349,
                -1217,
                -1520,
                -1075,
                -1502,
                -1157,
                -1426,
                -1238
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -118275,
                -84815,
                -86258,
                -97887,
                -79137,
                -81280,
                -92326,
                -83719,
                -97456,
                -78908,
                -78564,
                -90597
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1207,
                -1423,
                -1188,
                -1455,
                -1704,
                -1268,
                -1332,
                -1214,
                -1720,
                -1199,
                -1762,
                -1288
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -7724,
                -6545,
                -6145,
                -8745,
                -6353,
                -7378,
                -8525,
                -6976,
                -8408,
                -6895,
                -8864,
                -7818
              ]
            },
            "65010": {
              "name": "Rent",
              "monthly": [
                -132826,
                -129852,
                -124355,
                -120326,
                -147370,
                -127025,
                -125714,
                -122877,
                -148368,
                -148203,
                -111357,
                -118593
              ]
            },
            "65040": {
              "name": "Office Cleaning & Maintenance",
              "monthly": [
                -12951,
                -13211,
                -12229,
                -11678,
                -11780,
                -14342,
                -15526,
                -15470,
                -11852,
                -13925,
                -11870,
                -14535
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -432,
                -366,
                -559,
                -466,
                -454,
                -511,
                -536,
                -482,
                -479,
                -534,
                -397,
                -428
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -1016,
                -826,
                -1043,
                -847,
                -987,
                -1053,
                -890,
                -800,
                -1113,
                -1076,
                -1148,
                -967
              ]
            }
          }
        },
        "IT": {
          "monthly_total": [
            -64242,
            -48279,
            -42535,
            -51461,
            -66893,
            -54899,
            -61988,
            -62542,
            -65038,
            -50970,
            -59608,
            -51220
          ],
          "by_gl": {
            "15050": {
              "name": "Computer Equipment",
              "monthly": [
                -12960,
                -9097,
                -11565,
                -8950,
                -12456,
                -8913,
                -12415,
                -13311,
                -9585,
                -10397,
                -11554,
                -12944
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -22767,
                -13617,
                -13168,
                -16248,
                -13053,
                -15255,
                -14228,
                -15163,
                -15337,
                -12355,
                -10390,
                -14717
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -271,
                -261,
                -316,
                -277,
                -235,
                -238,
                -273,
                -278,
                -247,
                -247,
                -314,
                -226
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1604,
                -1391,
                -1524,
                -1579,
                -1161,
                -1603,
                -1199,
                -1113,
                -1120,
                -1259,
                -1618,
                -1509
              ]
            },
            "65030": {
              "name": "Internet",
              "monthly": [
                -881,
                -745,
                -956,
                -1102,
                -1004,
                -857,
                -991,
                -794,
                -781,
                -925,
                -823,
                -1085
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -19993,
                -27778,
                -25846,
                -30832,
                -37290,
                -19562,
                -26540,
                -24465,
                -26403,
                -26511,
                -23161,
                -27258
              ]
            },
            "66030": {
              "name": "IT Supplies & Small Equipments",
              "monthly": [
                -2667,
                -2398,
                -2500,
                -2574,
                -2647,
                -3109,
                -3128,
                -3260,
                -2466,
                -3047,
                -2327,
                -2948
              ]
            }
          }
        },
        "Design Control & Testing": {
          "monthly_total": [
            -150833,
            -168408,
            -147458,
            -186275,
            -136538,
            -173265,
            -174083,
            -144432,
            -207021,
            -163107,
            -149237,
            -99097
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                -5150,
                -3298,
                -4610,
                -3648,
                -4347,
                -4328,
                -5308,
                -5383,
                -3527,
                -5256,
                -3703,
                -3688
              ]
            },
            "51040": {
              "name": "Tools & Machine Tooling",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51050": {
              "name": "Machine Repairs & Maintenance",
              "monthly": [
                -3170,
                -2818,
                -2588,
                -3450,
                -2729,
                -3275,
                -3103,
                -3072,
                -3372,
                -2445,
                -3105,
                -3029
              ]
            },
            "51070": {
              "name": "External Testing Costs",
              "monthly": [
                -63441,
                -71572,
                -69286,
                -61415,
                -64334,
                -78115,
                -66600,
                -69926,
                -84327,
                -63500,
                -72890,
                -22943
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -76646,
                -60306,
                -78177,
                -101375,
                -76261,
                -78497,
                -80661,
                -66541,
                -99040,
                -71272,
                -65279,
                -91881
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -1646,
                -1369,
                -1302,
                -1377,
                -1231,
                -1387,
                -1623,
                -1517,
                -1193,
                -1348,
                -1524,
                -1468
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -6722,
                -6647,
                -8391,
                -7897,
                -7013,
                -6670,
                -5791,
                -5762,
                -7004,
                -5858,
                -7450,
                -6215
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Quality": {
          "monthly_total": [
            -75195,
            -154096,
            -59382,
            -70638,
            -45582,
            -55525,
            -59217,
            -57200,
            -68718,
            -62008,
            -55104,
            -75818
          ],
          "by_gl": {
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                -4277,
                -3214,
                -4145,
                -4474,
                -4580,
                -3061,
                -3535,
                -4614,
                -3249,
                -4400,
                -4053,
                -3588
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -51124,
                -39427,
                -45730,
                -43171,
                -35608,
                -35704,
                -54689,
                -38055,
                -54660,
                -36851,
                -47988,
                -62623
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -904,
                -867,
                -726,
                -830,
                -755,
                -888,
                -760,
                -726,
                -733,
                -697,
                -777,
                -808
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -4447,
                -4703,
                -4407,
                -4252,
                -3581,
                -5301,
                -3861,
                -4628,
                -4270,
                -5158,
                -4612,
                -5316
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -2030,
                -2527,
                -2944,
                -2204,
                -2523,
                -2710,
                -2165,
                -2374,
                -2864,
                -2564,
                -2737,
                -2178
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                -70317,
                0,
                0,
                -759,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            }
          }
        },
        "Clinical & Regulatory": {
          "monthly_total": [
            -955924,
            -479736,
            -503122,
            -447259,
            -448396,
            -445345,
            -442717,
            -456587,
            -582461,
            -480064,
            -399170,
            -601204
          ],
          "by_gl": {
            "15030": {
              "name": "Machinery & Equipment",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "51030": {
              "name": "Consumables",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "52100": {
              "name": "Animal Testing",
              "monthly": [
                -16356,
                -11887,
                -14571,
                -12878,
                -17112,
                -12027,
                -12899,
                -12431,
                -13982,
                -40821,
                -42750,
                -41528
              ]
            },
            "52200": {
              "name": "Clinical Trial Costs",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "53100": {
              "name": "Certifications & Compliance Audit",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "61010": {
              "name": "Salaries",
              "monthly": [
                -1034714,
                -260164,
                -320468,
                -427144,
                -324942,
                -299892,
                -449972,
                -343300,
                -326729,
                -323140,
                -293772,
                -327981
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -4351,
                -5309,
                -3883,
                -5187,
                -5304,
                -5573,
                -4191,
                -4373,
                -5635,
                -5157,
                -4635,
                -5522
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -22217,
                -23148,
                -29381,
                -29673,
                -29437,
                -25126,
                -27850,
                -25429,
                -26484,
                -28590,
                -23989,
                -23106
              ]
            },
            "61055": {
              "name": "Payroll Taxes (US)",
              "monthly": [
                -4406,
                -3994,
                -4171,
                -3616,
                -4283,
                -4781,
                -4430,
                -3518,
                -5192,
                -4067,
                -4667,
                -4376
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                -42889,
                -51007,
                -41464,
                -50738,
                -54445,
                -51249,
                -43090,
                -54606,
                -45454,
                -59295,
                -43281,
                -53692
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66040": {
              "name": "Custom, Duties, Brokerage Fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -2857,
                -3633,
                -2805,
                -3366,
                -4042,
                -3946,
                -2948,
                -2883,
                -3601,
                -3991,
                -3044,
                -3645
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "67040": {
              "name": "Conferences",
              "monthly": [
                -2931,
                -2842,
                -3391,
                -3206,
                -3026,
                -2679,
                -2983,
                -3391,
                -2872,
                -3036,
                -2532,
                -2633
              ]
            }
          }
        },
        "Intellectual Property": {
          "monthly_total": [
            -122892,
            -103859,
            -90241,
            -100531,
            -91366,
            -105107,
            -117192,
            -84877,
            -117441,
            -98720,
            -111912,
            -114524
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -26678,
                -23754,
                -18461,
                -28752,
                -21619,
                -25128,
                -22734,
                -17078,
                -30513,
                -20557,
                -23590,
                -22944
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -1253,
                -1152,
                -1318,
                -1287,
                -1124,
                -1169,
                -1210,
                -1337,
                -1341,
                -1047,
                -1007,
                -1033
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -449,
                -439,
                -406,
                -372,
                -377,
                -398,
                -352,
                -468,
                -477,
                -444,
                -487,
                -503
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -2301,
                -2092,
                -2284,
                -2072,
                -2691,
                -2087,
                -2243,
                -2549,
                -2133,
                -2006,
                -2497,
                -2400
              ]
            },
            "63021": {
              "name": "Patent Management & Patent Attorneys",
              "monthly": [
                -64395,
                -69337,
                -66514,
                -68405,
                -80166,
                -80469,
                -71852,
                -64296,
                -64600,
                -67192,
                -60216,
                -77474
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -1453,
                -1329,
                -1242,
                -1246,
                -1295,
                -20845,
                -1330,
                -1128,
                -1492,
                -1276,
                -1444,
                -1231
              ]
            }
          }
        },
        "Finance & Legal": {
          "monthly_total": [
            -101199,
            -158459,
            -74789,
            -89063,
            -200385,
            -153180,
            -92759,
            -80520,
            -73568,
            -76734,
            -89108,
            -81362
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -72449,
                -35978,
                -34721,
                -45876,
                -35937,
                -40679,
                -41383,
                -36415,
                -52589,
                -33397,
                -45874,
                -55328
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -863,
                -984,
                -870,
                -851,
                -869,
                -932,
                -701,
                -691,
                -784,
                -751,
                -951,
                -802
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -3723,
                -5156,
                -5102,
                -3717,
                -4078,
                -4648,
                -5098,
                -4822,
                -3547,
                -4468,
                -4824,
                -3834
              ]
            },
            "62010": {
              "name": "Contractor & Consulting fees",
              "monthly": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "63010": {
              "name": "Corporate Insurance",
              "monthly": [
                -8501,
                -110796,
                -6629,
                -6284,
                -5993,
                -5904,
                -7819,
                -7032,
                -7922,
                -8466,
                -8107,
                -7415
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -24211,
                -27572,
                -29658,
                -26868,
                -27383,
                -23843,
                -23970,
                -20425,
                -20312,
                -30031,
                -23421,
                -27358
              ]
            },
            "63030": {
              "name": "Audit & Tax",
              "monthly": [
                0,
                0,
                0,
                0,
                -94931,
                -45296,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                0,
                0,
                0,
                0,
                -53485,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]
            },
            "68010": {
              "name": "Bank Charges",
              "monthly": [
                -1731,
                -1229,
                -1857,
                -1311,
                -1849,
                -1480,
                -1337,
                -1314,
                -1673,
                -1422,
                -1672,
                -1931
              ]
            }
          }
        },
        "People": {
          "monthly_total": [
            -102101,
            -86785,
            -73796,
            -98113,
            -66195,
            -78217,
            -87017,
            -90848,
            -84749,
            -87769,
            -87778,
            -104043
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -25637,
                -18726,
                -21694,
                -20273,
                -20301,
                -18947,
                -20920,
                -19000,
                -22614,
                -21777,
                -16228,
                -24476
              ]
            },
            "61020": {
              "name": "Bonus",
              "monthly": [
                -334,
                -332,
                -397,
                -287,
                -318,
                -396,
                -350,
                -392,
                -280,
                -413,
                -327,
                -298
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -445,
                -391,
                -400,
                -488,
                -429,
                -427,
                -454,
                -334,
                -363,
                -479,
                -343,
                -389
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -1907,
                -1798,
                -1949,
                -2299,
                -2485,
                -2468,
                -2325,
                -2004,
                -2307,
                -1933,
                -2337,
                -1829
              ]
            },
            "61060": {
              "name": "Employee Benefits - Health Plan",
              "monthly": [
                -22589,
                -23849,
                -22200,
                -28662,
                -23991,
                -20941,
                -28892,
                -22227,
                -23606,
                -22304,
                -25588,
                -25178
              ]
            },
            "61070": {
              "name": "Employee Benefits - Cellphone",
              "monthly": [
                -7331,
                -5210,
                -6910,
                -6709,
                -6136,
                -6471,
                -6021,
                -6981,
                -6448,
                -7144,
                -5213,
                -6601
              ]
            },
            "61080": {
              "name": "Employee Benefits - Gym",
              "monthly": [
                -4827,
                -3705,
                -3556,
                -4759,
                -4511,
                -3464,
                -3810,
                -4831,
                -4241,
                -3711,
                -3641,
                -4039
              ]
            },
            "63020": {
              "name": "Legal & Immigration",
              "monthly": [
                -1742,
                -1755,
                -1879,
                -1826,
                -1994,
                -2060,
                -2036,
                -1958,
                -1627,
                -1650,
                -1789,
                -1834
              ]
            },
            "64020": {
              "name": "Recruiting Fees",
              "monthly": [
                -4070,
                -3042,
                -4589,
                -4491,
                -4896,
                -4219,
                -3570,
                -3502,
                -3322,
                -4295,
                -3848,
                -4156
              ]
            },
            "64050": {
              "name": "Team Training",
              "monthly": [
                -928,
                -875,
                -894,
                -843,
                -834,
                -825,
                -8684,
                -722,
                -792,
                -725,
                -727,
                -666
              ]
            },
            "64060": {
              "name": "Team Events & Gifts",
              "monthly": [
                -13190,
                -1934,
                -2577,
                -9328,
                -2901,
                -2879,
                -2462,
                -2312,
                -2260,
                -7773,
                -2780,
                -16746
              ]
            },
            "64070": {
              "name": "Team Meals",
              "monthly": [
                -4140,
                -4334,
                -4244,
                -4551,
                -4608,
                -3666,
                -4068,
                -4962,
                -5008,
                -5319,
                -3954,
                -5129
              ]
            },
            "66010": {
              "name": "Software Subscriptions",
              "monthly": [
                -648,
                -616,
                -744,
                -686,
                -682,
                -549,
                -660,
                -563,
                -720,
                -749,
                -667,
                -777
              ]
            },
            "66020": {
              "name": "Professional Licenses",
              "monthly": [
                -67,
                -57,
                -6552,
                -54,
                -51,
                -59,
                -54,
                -56,
                -58,
                -58,
                -64,
                -53
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -3470,
                -3655,
                -3955,
                -3552,
                -3713,
                -2890,
                -4137,
                -3507,
                -2911,
                -3938,
                -2914,
                -3177
              ]
            }
          }
        },
        "Executive": {
          "monthly_total": [
            -1941274,
            -796623,
            -1010225,
            -1186460,
            -969891,
            -1007515,
            -861868,
            -765132,
            -982850,
            -1003379,
            -1001203,
            -1121595
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -1137582,
                -433101,
                -611914,
                -663521,
                -457684,
                -541658,
                -644512,
                -499765,
                -586796,
                -466440,
                -483677,
                -765283
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -10807,
                -10907,
                -10653,
                -9551,
                -11193,
                -13157,
                -8912,
                -13265,
                -11188,
                -9483,
                -9313,
                -9858
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -55712,
                -69003,
                -58986,
                -57459,
                -47276,
                -55681,
                -60373,
                -61832,
                -60428,
                -54257,
                -52226,
                -59916
              ]
            },
            "66060": {
              "name": "Office & Team Supplies",
              "monthly": [
                -143,
                -136,
                -154,
                -138,
                -197,
                -185,
                -148,
                -149,
                -151,
                -193,
                -170,
                -154
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -6685,
                -6691,
                -8047,
                -7709,
                -7674,
                -6986,
                -5968,
                -8419,
                -7081,
                -7980,
                -5866,
                -6552
              ]
            },
            "67030": {
              "name": "Business Meals",
              "monthly": [
                -2634,
                -2938,
                -3917,
                -3132,
                -3462,
                -3464,
                -3916,
                -3433,
                -2580,
                -3071,
                -3003,
                -2816
              ]
            }
          }
        },
        "Commercial": {
          "monthly_total": [
            -514283,
            -101375,
            -126416,
            -146768,
            -113025,
            -130976,
            -147333,
            -115197,
            -143266,
            -126881,
            -115328,
            -159180
          ],
          "by_gl": {
            "61010": {
              "name": "Salaries",
              "monthly": [
                -481846,
                -115881,
                -113854,
                -135240,
                -91865,
                -109111,
                -102575,
                -94266,
                -139318,
                -79575,
                -82997,
                -115057
              ]
            },
            "61040": {
              "name": "Federal Payroll Taxes",
              "monthly": [
                -7008,
                -1976,
                -1860,
                -2565,
                -1933,
                -1900,
                -2256,
                -1919,
                -1836,
                -1715,
                -1530,
                -2135
              ]
            },
            "61050": {
              "name": "Quebec Payroll Taxes",
              "monthly": [
                -34863,
                -10030,
                -10685,
                -13010,
                -10017,
                -8219,
                -11292,
                -10326,
                -12418,
                -8993,
                -8082,
                -13006
              ]
            },
            "67010": {
              "name": "Travel & Hotel",
              "monthly": [
                -15885,
                -18334,
                -14889,
                -15344,
                -14378,
                -19902,
                -15408,
                -18160,
                -15901,
                -16146,
                -17191,
                -19403
              ]
            }
          }
        },
        "All company": {
          "monthly_total": [
            -4252265,
            -2734252,
            -2345836,
            -3087584,
            -3044760,
            -3048738,
            -3303821,
            -2549138,
            -3655518,
            -2488961,
            -2617486,
            -3386778
          ],
          "by_gl": {}
        }
      }
    }
  }
};
